import React, { Component } from "react";
import { connect } from "react-redux";
import { getOrders, updateOrders, getSESProducts, setSIVProductInventoryTransaction } from "../actions";
import { Container, Row, Col, Button, Form, Table, Badge, Spinner, FormSelect, FormCheck, InputGroup, Modal, Toast } from "react-bootstrap";
import { Modal as StrapModal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { FaCheck, FaEdit, FaHistory, FaPrint, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { getDiffSecondsFromNowVN } from "../utils/datetime";
import ScanOrders from "./ScanOrders";
import { getTranslate, LANGUAGE_KEYS } from '../utils/language';
import { getApiUrl } from '../utils/platform';
import { getToken } from '../utils/token';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { API } from "../services/API";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import IframeModal from '../components/IframeModal/IframeModal';
import axios from 'axios';
import QRCode from 'react-qr-code';
import ReactDOMServer from 'react-dom/server';
import { Link } from 'react-router-dom';

// Create a wrapper component to handle hooks
const OrderListWrapper = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let targetPage = searchParams.get('target_page') || 'sale';
  if (location.pathname.includes('/rnd/orders')) {
    targetPage = 'rnd';
      } else if (location.pathname.includes('/sale/orders')) {
      targetPage = 'sale';
    } else if (location.pathname.includes('/fulfill/orders')) {
      targetPage = 'fulfill';
  }
  console.log('OrderListWrapper targetPage:', targetPage); // Debug log
  return <OrderList {...props} targetPage={targetPage} />;
};

class OrderList extends Component {
  state = {
    loading: false,
    dateFilter: 'yesterday', // today, yesterday, this_week, this_month, three_months, all
    selectedOrders: new Set(),
    showEditModal: false,
    currentListing: null,
    currentOrder: null,
    editForm: {
      sku: '',
      size: '',
      title: '',
      buyer_note: '',
      seller_note: '',
      priority: 2,
      customer_name: '',
      email: '',
      shipping_address: '',
      order_date: new Date()
    },
    isNewSize: false,
    editingNote: null,
    noteValue: '',
    showConfigModal: false,
    columnVisibility: {
      stt: true, // Thêm cột STT
      orderDate: true,
      monthlyId: true,
      orderId: true,
      shop: true,
      customer: true,
      status: true,
      priority: true,
      sku: true,
      image: true,
      title: true,
      size: true,
      quantity: true,  // Thêm field quantity
      buyerNote: true,
      sellerNote: true,
      estDelivery: true,
      shippingAddress: true,
      email: true,
      ioss: true,
      available: true,
      shippingCenterDate: true,
      action: true
    },
    showScanOrdersModal: false,
    currentPage: 1,
    itemsPerPage: parseInt(localStorage.getItem('orderItemsPerPage')) || 20,
    totalCount: 0,
    selectedBulkStatus: '',
    targetPage: 'sale', // Default to sale
    showRndDoneModal: false,
    rndNoteValue: '',
    rndOrderId: null,
    sortBy: 'monthly_id',
    sortOrder: 'asc',
    shopFilter: localStorage.getItem(`orderShopFilter_sale`) || 'All',
    statusFilter: localStorage.getItem(`orderStatusFilter_sale`) || '',
    keyword: localStorage.getItem(`orderKeyword_sale`) || '',
    showLogModal: false,
    currentOrderLogs: [],
    isShowLatestLog: true,
    isShowSystemInfo: true,
    currentOrderForLog: null,
    logPagination: {
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 100
    },
    productListLoaded: false,
    showWarehouseModal: false, // Add new state for warehouse modal
    showFulfillLabelModal: false, // Add new state for fulfill label modal
    // Add toast state
    showToast: false,
    toastMessage: '',
    toastVariant: 'success',
    activeTab: '1', // Add new state for active tab
    showAddOrderModal: false,
    newOrderForm: {
      shop_name: '', // Reset to empty to force user selection
      customer_name: '',
      email: '',
      shipping_address: '',
      buyer_note: '',
      seller_note: '',
      priority: 2,
      added_reason: 'ETSY_WARRANTY_ORDER', // Changed default to warranty order
      reference_code: '', // Add reference code field
      order_date: new Date(), // Add order_date field
      listings: [{
        sku: '',
        size: '',
        title: '',
        img_url: ''
      }]
    },
    shopOptions: [
      { value: 'ResinEpic', label: 'ResinEpic' },
      { value: 'GiftSymphony', label: 'GiftSymphony' }
    ],
    currentListingIndex: null, // Add new state for current listing index
    isAddingListing: false, // Add flag to indicate we're adding a listing
    logLevelFilter: 'ALL',
    editingBuyerNote: null,
    buyerNoteValue: '',
    editMode: 'listing',
    editListingIndex: null,
    // Thêm state cho xuất hàng fulfill
    showExportModal: false,
    exportItems: [],
    exportWarehouse: '',
    exportNote: '',
    exportSaving: false,
    exportViewProduct: false,
    // Add stick header state
    stickHeader: localStorage.getItem(`orderStickHeader_${this.props.targetPage || 'sale'}`) === 'true' || false,
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const targetPage = this.props.targetPage || 'sale';
    // Đọc date_filter theo targetPage
    const localDateFilter = localStorage.getItem(`orderDateFilter_${targetPage}`);
    const dateFilter = localDateFilter || searchParams.get('date_filter') || 'yesterday';
    const page = parseInt(searchParams.get('page')) || 1;
    const perPage = parseInt(searchParams.get('per_page')) || parseInt(localStorage.getItem(`orderItemsPerPage_${targetPage}`)) || 20;
    // Đọc shop filter theo targetPage
    const localShopFilter = localStorage.getItem(`orderShopFilter_${targetPage}`) || 'All';
    const localStatusFilter = localStorage.getItem(`orderStatusFilter_${targetPage}`) || '';
    const localKeyword = localStorage.getItem(`orderKeyword_${targetPage}`) || '';
    // Đọc stick header setting theo targetPage
    const localStickHeader = localStorage.getItem(`orderStickHeader_${targetPage}`) === 'true' || false;

    // Load saved column visibility from localStorage per targetPage
    const savedVisibility = localStorage.getItem(`orderColumnVisibility_${targetPage}`);
    let columnVisibility = this.state.columnVisibility;
    if (savedVisibility) {
      try {
        const parsedVisibility = JSON.parse(savedVisibility);
        columnVisibility = { ...columnVisibility, ...parsedVisibility };
      } catch (e) {
        console.error("Failed to parse column visibility from localStorage", e);
      }
    }

    this.setState({ 
      targetPage,
      dateFilter,
      currentPage: page,
      itemsPerPage: perPage,
      shopFilter: localShopFilter,
      statusFilter: localStatusFilter,
      keyword: localKeyword,
      columnVisibility,
      stickHeader: localStickHeader
    }, () => {
      this.updateURL({
        date_filter: dateFilter,
        page,
        per_page: perPage
      });
      this.loadOrders();
    });

    if (!this.props.products || this.props.products.length === 0) {
      this.setState({ productListLoaded: true }); // Set flag to prevent multiple calls
      this.props.getSESProducts({ currentPage: 1, itemsPerPage: 9999, sortBy: 'product_code', sortOrder: 1 });
    }
  }

  componentDidUpdate(prevProps) {
    // Reset productListLoaded flag when products are successfully loaded
    if ((!prevProps.products || prevProps.products.length === 0) && 
        (this.props.products && this.props.products.length > 0) && 
        this.state.productListLoaded) {
      console.log('DEBUG: Products loaded successfully, resetting productListLoaded flag');
      this.setState({ productListLoaded: false });
    }
  }

  updateURL = (params) => {
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([key, value]) => {
      if (key === 'target_page' && this.props.query?.target_page) {
        // Nếu target_page đã được truyền từ props.query thì không update
        return;
      }
      if (value) {
        searchParams.set(key, value);
      } else {
        searchParams.delete(key);
      }
    });
    const newURL = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newURL);
  };

  getDateFilterValue = (filter) => {
    const today = moment().startOf('day');
    let from = '', to = '';
    switch (filter) {
      case 'today':
        from = today.format('YYYY-MM-DD');
        to = today.format('YYYY-MM-DD');
        break;
      case 'yesterday':
        from = today.clone().subtract(1, 'days').format('YYYY-MM-DD');
        to = from;
        break;
      case 'this_week':
        from = today.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD'); // Monday
        to = today.format('YYYY-MM-DD');
        break;
      case 'last_week':
        from = today.clone().subtract(1, 'weeks').startOf('week').add(1, 'days').format('YYYY-MM-DD');
        to = today.clone().subtract(1, 'weeks').endOf('week').add(1, 'days').format('YYYY-MM-DD');
        break;
      case 'this_month':
        from = today.clone().startOf('month').format('YYYY-MM-DD');
        to = today.format('YYYY-MM-DD');
        break;
      case 'last_month':
        from = today.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        to = today.clone().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        break;
      case 'all':
        from = '';
        to = '';
        break;
      default:
        from = today.format('YYYY-MM-DD');
        to = today.format('YYYY-MM-DD');
    }
    return { from, to };
  };

  loadOrders = () => {
    this.setState({ loading: true });
    const { from, to } = this.getDateFilterValue(this.state.dateFilter);
    const targetPage = this.props.targetPage || this.state.targetPage;
    const params = {
      order_date_from: from,
      order_date_to: to,
      currentPage: this.state.currentPage,
      itemsPerPage: this.state.itemsPerPage,
      target_page: targetPage
    };
    // Ưu tiên filter status nếu có chọn
    if (this.state.statusFilter !== '') {
      params.status = this.state.statusFilter;
    } else if (targetPage === 'rnd') {
      params.status = 4; // Chỉ lấy đơn custom
    } else if (targetPage === 'fulfill') {
      params.status = '10,11,12'; // Thêm status 13 vào danh sách
    }
    // Truyền shop_name nếu khác All
    if (this.state.shopFilter && this.state.shopFilter !== 'All') {
      params.shop_name = this.state.shopFilter;
    }
    if (this.state.sortBy) {
      params.sort = (this.state.sortOrder === 'asc' ? '' : '-') + this.state.sortBy;
    } else {
      params.sort = 'monthly_id'; // Mặc định giảm dần theo monthly_id
    }
    if (this.state.keyword) {
      params.keyword = this.state.keyword;
    }
    this.props.getOrders(params)
      .then(response => {
        this.setState({ 
          totalCount: response.totalCount || 0
        });
      })
      .catch(error => {
        console.error('Error loading orders:', error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleDateFilterChange = (e) => {
    const dateFilter = e.target.value;
    // Lưu date_filter theo targetPage
    localStorage.setItem(`orderDateFilter_${this.state.targetPage}`, dateFilter);
    this.setState({ dateFilter }, () => {
      this.updateURL({ date_filter: dateFilter, page: 1 });
      this.loadOrders();
    });
  };

  handleShopFilterChange = (e) => {
    const shopFilter = e.target.value;
    localStorage.setItem(`orderShopFilter_${this.state.targetPage}`, shopFilter);
    this.setState({ shopFilter, currentPage: 1 }, () => {
      // Update URL với shop_name
      if (shopFilter && shopFilter !== 'All') {
        this.updateURL({ shop_name: shopFilter, page: 1 });
      } else {
        this.updateURL({ shop_name: '', page: 1 });
      }
      this.loadOrders();
    });
  };

  handleStatusFilterChange = (e) => {
    const statusFilter = e.target.value;
    localStorage.setItem(`orderStatusFilter_${this.state.targetPage}`, statusFilter);
    this.setState({ statusFilter, currentPage: 1 }, () => {
      // Update URL với status
      if (statusFilter) {
        this.updateURL({ status: statusFilter, page: 1 });
      } else {
        this.updateURL({ status: '', page: 1 });
      }
      this.loadOrders();
    });
  };

  handleEditFormChange = (e) => {
    const { name, value } = e.target;
    if (name === 'sku') {
      // Tìm sản phẩm theo SKU và tự động fill tên
      const selectedProduct = (this.props.products || []).find(p => p.sku_code === value);
      this.setState({
        editForm: {
          ...this.state.editForm,
          sku: value,
          title: selectedProduct ? selectedProduct.product_name : ''
        }
      });
    } else {
      this.setState({
        editForm: {
          ...this.state.editForm,
          [name]: value
        }
      });
    }
  };

  handleSizeChange = (e) => {
    const value = e.target.value;
    if (value === 'new') {
      this.setState({ 
        isNewSize: true, 
        editForm: {
          ...this.state.editForm,
          size: ''
        }
      });
    } else {
      this.setState({ 
        isNewSize: false,
        editForm: {
          ...this.state.editForm,
          size: value
        }
      });
    }
  };

  getPerformByTeam = () => {
    const { targetPage } = this.state;
    switch (targetPage) {
      case 'rnd':
        return 'RND';
      case 'sale':
        return 'SALE';
      case 'fulfill':
        return 'FULFILL';
      default:
        return 'SALE';
    }
  };

  handleEditSubmit = () => {
    const { currentOrder, currentListing, editForm, currentListingIndex, isAddingListing, editMode } = this.state;
    if (currentOrder) {
      let updatedListings;
      if (isAddingListing) {
        // Verify product details from products list
        const selectedProduct = this.props.products.find(p => p.product_code === currentListing.product_code);
        if (!selectedProduct) {
          this.handleShowToast('Invalid product selection', 'danger');
          return;
        }

        // Add new listing with verified product details
        updatedListings = [...currentOrder.listings, {
          sku: selectedProduct.sku_code,
          size: selectedProduct.size,
          title: selectedProduct.product_name,
          img_url: selectedProduct.images && selectedProduct.images.length > 0 
            ? selectedProduct.images[0].image_link 
            : '',
          product_code: selectedProduct.product_code,
          quantity: editForm.quantity
        }];
      } else {
        console.log('DEBUG handleEditSubmit: currentListingIndex', currentListingIndex);
        // Edit existing listing - make sure to preserve all other listings exactly as they are
        updatedListings = currentOrder.listings.map((listing, index) => {
          if (index === currentListingIndex) {
            // Only update the listing at the specified index
            const selectedProduct = this.props.products.find(p => p.product_code === currentListing.product_code);
            if (!selectedProduct) {
              this.handleShowToast('Invalid product selection', 'danger');
              return listing; // Return original listing if product not found
            }
            return {
              ...listing, // Preserve any other fields from the original listing
              sku: selectedProduct.sku_code,
              size: selectedProduct.size,
              title: selectedProduct.product_name,
              img_url: selectedProduct.images && selectedProduct.images.length > 0 
                ? selectedProduct.images[0].image_link 
                : listing.img_url, // Fallback to original img_url if no new image
              product_code: selectedProduct.product_code,
              quantity: editForm.quantity
            };
          }
          return listing; // Return unchanged listing for all other indices
        });
      }

      const updatedOrderPayload = {
        order_id: currentOrder.order_id,
        shop_id: currentOrder.shop_id,
        listings: updatedListings,
        perform_by_team: this.getPerformByTeam()
      };

      // Only include customer info if editing order (not just listing)
      if (editMode === 'order' || !editMode) {
        updatedOrderPayload.buyer_note = editForm.buyer_note;
        updatedOrderPayload.seller_note = editForm.seller_note;
        updatedOrderPayload.priority = editForm.priority;
        updatedOrderPayload.customer_name = editForm.customer_name;
        updatedOrderPayload.email = editForm.email;
        updatedOrderPayload.shipping_address = editForm.shipping_address;
        if (editForm.order_date) {
          updatedOrderPayload.order_date = editForm.order_date.toISOString();
        }
        updatedOrderPayload.ioss = editForm.ioss;
      }

      console.log('DEBUG handleEditSubmit: updated listing', updatedListings);
      console.log('Updated Order Payload:', updatedOrderPayload);

      this.props.updateOrders([updatedOrderPayload])
        .then(() => {
          this.setState({ 
            showEditModal: false,
            isAddingListing: false,
            currentListingIndex: null,
            editMode: null
          });
          this.loadOrders();
          this.handleShowToast(isAddingListing ? 'Listing added successfully' : 'Order updated successfully');
        })
        .catch(error => {
          console.error('Error updating order:', error);
          this.handleShowToast(isAddingListing ? 'Failed to add listing' : 'Failed to update order', 'danger');
        });
    }
  };
  

  handleDeleteListing = () => {
    const { currentOrder, currentListing } = this.state;
    if (currentOrder) {
      if (currentOrder.listings.length > 1) {
        // Filter out the current listing before updating
        const updatedListings = currentOrder.listings.filter(listing => 
          !(listing.sku === currentListing.sku && listing.size === currentListing.size)
        );
        const updatedOrder = {
          order_id: currentOrder.order_id,
          shop_id: currentOrder.shop_id,
          listings: updatedListings,
          perform_by_team: this.getPerformByTeam()
        };
        console.log('DEBUG handleDeleteListing: updated listings', updatedListings);
        this.props.updateOrders([updatedOrder])
          .then(() => {
            this.setState({ showEditModal: false });
            this.loadOrders();
            this.handleShowToast('Listing deleted successfully');
          })
          .catch(error => {
            console.error('Error deleting listing:', error);
            this.handleShowToast('Failed to delete listing', 'danger');
          });
      } else {
        // Chỉ còn 1 listing, xoá cả order
        const updatedOrder = {
          order_id: currentOrder.order_id,
          shop_id: currentOrder.shop_id,
          is_deleted: true,
          perform_by_team: this.getPerformByTeam()
        };
        this.props.updateOrders([updatedOrder])
          .then(() => {
            this.setState({ showEditModal: false });
            this.loadOrders();
            this.handleShowToast('Order deleted successfully');
          })
          .catch(error => {
            console.error('Error deleting order:', error);
            this.handleShowToast('Failed to delete order', 'danger');
          });
      }
    }
  };

  handleOrderSelect = (orderId) => {
    const selectedOrders = new Set(this.state.selectedOrders);
    if (selectedOrders.has(orderId)) {
      selectedOrders.delete(orderId);
    } else {
      selectedOrders.add(orderId);
    }
    this.setState({ selectedOrders });
  };

  handleBulkStatusChange = (e) => {
    this.setState({ selectedBulkStatus: e.target.value });
  };

  handleBulkStatusApply = () => {
    if (!this.state.selectedBulkStatus || this.state.selectedOrders.size === 0) return;
    
    const orderIds = Array.from(this.state.selectedOrders);
    const ordersToUpdate = orderIds.map(id => ({
      order_id: id,
      status: parseInt(this.state.selectedBulkStatus),
      perform_by_team: this.getPerformByTeam()
    }));

    console.log('Bulk updating orders:', ordersToUpdate);

    this.props.updateOrders(ordersToUpdate)
      .then(() => {
        this.setState({ 
          selectedOrders: new Set(),
          selectedBulkStatus: ''
        });
        this.loadOrders();
        this.handleShowToast(`Updated status for ${orderIds.length} orders successfully`);
      })
      .catch(error => {
        console.error('Error bulk updating orders:', error);
        this.handleShowToast('Failed to update orders in bulk', 'danger');
      });
  };

  handleNoteEdit = (orderId) => {
    this.setState({
      editingNote: orderId,
      noteValue: this.props.orders.find(o => o.order_id === orderId)?.seller_note || ''
    });
  };

  handleNoteChange = (e) => {
    this.setState({ noteValue: e.target.value });
  };

  handleNoteSave = (orderId) => {
    const order = this.props.orders.find(o => o.order_id === orderId);
    if (order) {
      const updatedOrder = {
        order_id: order.order_id,
        shop_id: order.shop_id,
        seller_note: this.state.noteValue,
        perform_by_team: this.getPerformByTeam()
      };

      this.props.updateOrders([updatedOrder], { isUpdated: true })
        .then(() => {
          this.setState({ editingNote: null });
        })
        .catch(error => {
          console.error('Error updating note:', error);
          alert("Failed to update note. See console for details.");
        });
    }
  };

  handleConfigToggle = () => {
    this.setState({ showConfigModal: !this.state.showConfigModal });
  };

  handleColumnToggle = (column) => {
    this.setState(prevState => {
      const newColumnVisibility = {
        ...prevState.columnVisibility,
        [column]: !prevState.columnVisibility[column]
      };
      // Save to localStorage with targetPage
      localStorage.setItem(`orderColumnVisibility_${prevState.targetPage}`, JSON.stringify(newColumnVisibility));
      return { columnVisibility: newColumnVisibility };
    });
  };

  handleStickHeaderToggle = () => {
    this.setState(prevState => {
      const newStickHeader = !prevState.stickHeader;
      // Save to localStorage with targetPage
      localStorage.setItem(`orderStickHeader_${prevState.targetPage}`, newStickHeader.toString());
      return { stickHeader: newStickHeader };
    });
  };

  handleSaveConfig = () => {
    // Save to localStorage with targetPage
    localStorage.setItem(`orderColumnVisibility_${this.state.targetPage}`, JSON.stringify(this.state.columnVisibility));
    this.setState({ showConfigModal: false });
  };

  handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    const targetPage = this.props.targetPage || this.state.targetPage;
    localStorage.setItem(`orderItemsPerPage_${targetPage}`, newItemsPerPage);
    this.setState({ 
      itemsPerPage: newItemsPerPage,
      currentPage: 1
    }, () => {
      this.updateURL({ per_page: newItemsPerPage, page: 1 });
      this.loadOrders();
    });
  };

  handlePageChange = (page) => {
    if (page === this.state.currentPage) return;
    this.setState({ currentPage: page }, () => {
      this.updateURL({ page });
      this.loadOrders();
    });
  };

  getOrderStatusInfo = (status) => {
    const statusMap = {
      0: { bgColor: '#ff3b30', text: 'CANCELLED', textColor: '#fff' },
      1: { bgColor: '#ff9500', text: 'WAITING_FOR_PAYMENT', textColor: '#fff' },
      2: { bgColor: '#5ac8fa', text: 'WAIT_FOR_PROCESSING', textColor: '#222' },
      3: { bgColor: '#007aff', text: 'PROCESSING', textColor: '#fff' },
      4: { bgColor: '#b266ff', text: 'PROCESSING_CUSTOM_ORDER', textColor: '#fff' },
      10: { bgColor: '#5ac8fa', text: 'FULFILL_PROCESSING', textColor: '#222' },
      11: { bgColor: '#FFC300', text: 'PACKAGING', textColor: '#222' },
      12: { bgColor: '#32d74b', text: 'DONE_PACKAGING', textColor: '#fff' },
      13: { bgColor: '#30b0c7', text: 'SHIPPED_TO_SHIPPING_CENTER', textColor: '#fff' },
      20: { bgColor: '#ff6f91', text: 'SHIPPED_TO_CUSTOMER', textColor: '#fff' },
      21: { bgColor: '#ffa500', text: 'CUSTOMS_HOLD', textColor: '#fff' },
      22: { bgColor: '#6ee7b7', text: 'RETURNED_TO_SHIPPING_WAREHOUSE', textColor: '#222' },
      23: { bgColor: '#6ee7b7', text: 'RETURNED_TO_SHIPPING_CENTER', textColor: '#222' },
      24: { bgColor: '#6ee7b7', text: 'RETURNED_TO_WAREHOUSE', textColor: '#222' },
      30: { bgColor: '#228B22', text: 'COMPLETED', textColor: '#fff' },
      31: { bgColor: '#ff4500', text: 'REFUNDED', textColor: '#fff' },
    };
    return statusMap[Number(status)] || { bgColor: '#0099ff', text: 'UNKNOWN', textColor: '#fff' };
  };

  getAvailableStatuses = (currentStatus) => {
    const availableStatuses = [];
    const { orders = [] } = this.props;
    const targetPage = this.props.targetPage || this.state.targetPage;
    // Count orders for each status
    const statusCounts = orders.reduce((acc, order) => {
      acc[order.status] = (acc[order.status] || 0) + 1;
      return acc;
    }, {});

    // Danh sách status mới
    const statusList = [
      0, 1, 2, 3, 4, 10, 11, 12, 13, 20, 21, 22, 23, 24, 30, 31
    ];

    if (targetPage === 'sale') {
      statusList.forEach(i => {
        availableStatuses.push({
          value: i,
          count: statusCounts[i] || 0,
          ...this.getOrderStatusInfo(i)
        });
      });
    } else if (targetPage === 'fulfill') {
      // Fulfill chỉ lấy các trạng thái fulfill trở đi
      [10, 11, 12, 13, 20, 21, 22, 23, 24, 30, 31].forEach(i => {
        availableStatuses.push({
          value: i,
          count: statusCounts[i] || 0,
          ...this.getOrderStatusInfo(i)
        });
      });
    } else if (targetPage === 'rnd') {
      return [];
    }
    return availableStatuses;
  };

  handleStatusChange = (orderId, newStatus) => {
    const order = this.props.orders.find(o => o.order_id === orderId);
    if (order) {
      const updatedOrder = {
        order_id: order.order_id,
        shop_id: order.shop_id,
        status: parseInt(newStatus),
        perform_by_team: this.getPerformByTeam()
      };

      this.props.updateOrders([updatedOrder])
        .then(() => {
          this.handleShowToast(`Order ${orderId} status updated successfully`);
        })
        .catch(error => {
          console.error('Error updating status:', error);
          this.handleShowToast('Failed to update status', 'danger');
        });
    }
  };

  getPriorityInfo = (priority) => {
    const priorityMap = {
      1: { color: 'secondary', text: 'TEXT_PRIORITY_LOW', bgColor: '#6c757d', textColor: '#ffffff' },
      2: { color: 'info', text: 'TEXT_PRIORITY_MEDIUM', bgColor: '#0dcaf0', textColor: '#000000' },
      3: { color: 'warning', text: 'TEXT_PRIORITY_HIGH', bgColor: '#ffc107', textColor: '#000000' },
      4: { color: 'danger', text: 'TEXT_PRIORITY_EXPRESS', bgColor: '#dc3545', textColor: '#ffffff' }
    };
    return priorityMap[priority] || { color: 'secondary', text: 'TEXT_PRIORITY_LOW', bgColor: '#6c757d', textColor: '#ffffff' };
  };

  handlePriorityChange = (orderId, newPriority) => {
    const order = this.props.orders.find(o => o.order_id === orderId);
    if (order) {
      const updatedOrder = {
        order_id: order.order_id,
        shop_id: order.shop_id,
        priority: parseInt(newPriority),
        perform_by_team: this.getPerformByTeam()
      };

      this.props.updateOrders([updatedOrder])
        .then(() => {
          this.handleShowToast(`Order ${orderId} priority updated successfully`);
        })
        .catch(error => {
          console.error('Error updating priority:', error);
          this.handleShowToast('Failed to update priority', 'danger');
        });
    }
  };

  renderStatusBadge = (status) => {
    const statusInfo = this.getOrderStatusInfo(status);
    return (
      <span className="badge" style={{ background: statusInfo.bgColor, color: '#fff', minWidth: 24, display: 'inline-block' }}>&nbsp;</span>
    );
  };

  renderPriorityOption = (priority) => {
    const priorityInfo = this.getPriorityInfo(priority);
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: priorityInfo.bgColor,
          border: '1px solid #ccc'
        }} />
        <span>[{priority}] {getTranslate(LANGUAGE_KEYS[priorityInfo.text])}</span>
      </div>
    );
  };

  renderPriorityBadge = (priority) => {
    const priorityInfo = this.getPriorityInfo(priority);
    return (
      <Badge 
        bg={priorityInfo.color}
        style={{
          backgroundColor: priorityInfo.bgColor,
          color: priorityInfo.textColor,
          padding: '5px 10px',
          fontWeight: 'bold'
        }}
      >
        {getTranslate(LANGUAGE_KEYS[priorityInfo.text])}
      </Badge>
    );
  };

  // Add method to check if feature is enabled for current target page
  isFeatureEnabled = (feature) => {
    const { targetPage } = this.state;
    switch (feature) {
      case 'scan_orders':
        return targetPage === 'sale';
      case 'bulk_update':
        return targetPage === 'sale' || targetPage === 'fulfill';
      case 'edit_notes':
        return targetPage === 'sale' || targetPage === 'fulfill';
      case 'edit_priority':
        return targetPage === 'rnd' || targetPage === 'fulfill';
      default:
        return false;
    }
  };

  handleShowRndDoneModal = (orderId) => {
    this.setState({ showRndDoneModal: true, rndOrderId: orderId, rndNoteValue: '' });
  };

  handleRndNoteChange = (e) => {
    this.setState({ rndNoteValue: e.target.value });
  };

  handleRndDoneSubmit = () => {
    const { rndOrderId, rndNoteValue } = this.state;
    const order = this.props.orders.find(o => o.order_id === rndOrderId);
    if (!order) return;
    const now = new Date();
    const dateStr = now.toLocaleString();
    const newSellerNote = (order.seller_note ? order.seller_note + '\n' : '') + `[${dateStr}] [RnD Note]: ${rndNoteValue}`;
    const updatedOrder = {
      order_id: order.order_id,
      shop_id: order.shop_id,
      status: 3, // Chuyển về Đang xử lý
      seller_note: newSellerNote,
      perform_by_team: 'RND'
    };
    this.props.updateOrders([updatedOrder])
      .then(() => {
        this.setState({ showRndDoneModal: false, rndOrderId: null, rndNoteValue: '' });
        this.loadOrders();
      })
      .catch(error => {
        alert('Failed to update order. See console for details.');
      });
  };

  handleSort = (field) => {
    let sortOrder = 'asc';
    if (this.state.sortBy === field) {
      sortOrder = this.state.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    this.setState({ sortBy: field, sortOrder }, () => {
      this.loadOrders();
    });
  };

  handleKeywordChange = (e) => {
    this.setState({ keyword: e.target.value });
  };

  handleKeywordSearch = (e) => {
    if (e.type === 'blur' || (e.type === 'keydown' && e.key === 'Enter')) {
      const keyword = e.target.value.trim();
      localStorage.setItem(`orderKeyword_${this.state.targetPage}`, keyword);
      this.setState({ keyword, currentPage: 1 }, () => {
        if (keyword) {
          this.updateURL({ keyword, page: 1 });
        } else {
          this.updateURL({ keyword: '', page: 1 });
        }
        this.loadOrders();
      });
    }
  };

  handleViewLogs = (order) => {
    this.setState({ 
      showLogModal: true,
      currentOrderForLog: order,
      currentOrderLogs: []
    }, () => {
      this.fetchOrderLogs(order.order_id);
    });
  };

  fetchOrderLogs = async (orderId, page = 1) => {
    try {
      const response = await API.get(`${getApiUrl()}/api/order/get-logs/${orderId}?page=${page}`);
      const { logs, totalCount, currentPage, totalPages, limit } = response.data.data;
      this.setState({ 
        currentOrderLogs: logs,
        logPagination: {
          currentPage,
          totalPages,
          totalCount,
          limit
        }
      });
    } catch (error) {
      console.error('Error fetching order logs:', error);
    }
  };

  handleToggleShowLatestLog = () => {
    this.setState(prevState => ({
      isShowLatestLog: !prevState.isShowLatestLog
    }));
  };

  handleToggleShowSystemInfo = () => {
    this.setState(prevState => ({
      isShowSystemInfo: !prevState.isShowSystemInfo
    }));
  };

  handleGetLatestLog = () => {
    if (this.state.currentOrderForLog) {
      this.fetchOrderLogs(this.state.currentOrderForLog.order_id);
    }
  };

  handleLogPageChange = (page) => {
    if (this.state.currentOrderForLog) {
      this.fetchOrderLogs(this.state.currentOrderForLog.order_id, page);
    }
  };

  handleAddListing = () => {
    const { currentOrder } = this.state;
    if (currentOrder) {
      const newListing = {
        sku: '',
        size: '',
        title: '',
        img_url: '',
      };
      const updatedListings = [...currentOrder.listings, newListing];
      this.setState({
        currentOrder: {
          ...currentOrder,
          listings: updatedListings
        },
        currentListing: newListing,
        editForm: {
          sku: '',
          size: '',
          title: '',
          buyer_note: currentOrder.buyer_note || '',
          seller_note: currentOrder.seller_note || '',
          priority: currentOrder.priority || 2,
          quantity: 1
        },
        showEditModal: true
      });
    } else {
      // Nếu chưa có order nào đang sửa, tạo order rỗng để thêm listing mới
      this.setState({
        currentOrder: {
          order_id: '',
          shop_id: '',
          listings: [{ sku: '', size: '', title: '', img_url: '' }],
          buyer_note: '',
          seller_note: '',
          priority: 2
        },
        currentListing: { sku: '', size: '', title: '', img_url: '' },
        editForm: {
          sku: '',
          size: '',
          title: '',
          buyer_note: '',
          seller_note: '',
          priority: 2,
          quantity: 1
        },
        showEditModal: true
      });
    }
  };

  handleAddListingToOrder = (order) => {
    // Do NOT add a new listing to order.listings here!
    const newListing = {
      product_code: '',
      sku: '',
      size: '',
      title: '',
      img_url: ''
    };
    this.setState({
      currentOrder: order,
      currentListing: newListing,
      editForm: {
        sku: '',
        size: '',
        title: '',
        product_code: '',
        quantity: 1
      },
      showEditModal: true,
      isAddingListing: true,
      currentListingIndex: null
    });
  };

  handleAutoFulfill = async () => {
    try {
      await this.props.getSESProducts({ currentPage: 1, itemsPerPage: 9999, sortBy: 'product_code', sortOrder: 1 });
      const { products = [], orders = [] } = this.props;
      const fulfillOrders = orders.filter(order => order.status === 10);
      const stockMap = {};
      const cellCodeMap = {};
      products.forEach(product => {
        const key = product.product_code;
        stockMap[key] = product.current_qty || 0;
        cellCodeMap[key] = product.current_cell_code;
      });

      const updatedOrders = fulfillOrders.map(order => {
        const newListings = order.listings.map(listing => {
          const key = `${listing.sku}-${listing.size}`;
          if (listing.available === -1) {
            return listing;
          }
          if (listing.available === 2) {
            if (stockMap[key] > 0) stockMap[key] -= 1;
            return listing;
          }
          if (stockMap[key] > 0) {
            stockMap[key] -= 1;
            return { 
              ...listing, 
              available: 1,
              current_cell_code: cellCodeMap[key] || listing.current_cell_code
            };
          } else {
            return { ...listing, available: 0 };
          }
        });
        return { ...order, listings: newListings };
      });

      for (const order of updatedOrders) {
        await this.props.updateOrders([
          {
            order_id: order.order_id,
            shop_id: order.shop_id,
            listings: order.listings,
            perform_by_team: 'FULFILL'
          }
        ]);
      }
      this.handleShowToast('Auto Fulfill completed successfully');
      this.loadOrders();
    } catch (error) {
      console.error('Error in auto fulfill:', error);
      this.handleShowToast('Failed to complete auto fulfill', 'danger');
    }
  };

  handleAvailableChange = async (orderId, listingSku, newAvailable) => {
    const order = this.props.orders.find(o => o.order_id === orderId);
    const { products = [] } = this.props;
    
    if (order) {
      const updatedListings = order.listings.map(listing => {
        if (listing.sku === listingSku) {
          const matchingProduct = products.find(p => p.sku_code === listingSku);
          console.log('Matching product for SKU:', listingSku, matchingProduct);
          const updatedListing = { 
            ...listing, 
            available: parseInt(newAvailable)
          };
          
          if (matchingProduct?.current_cell_code) {
            updatedListing.current_cell_code = matchingProduct.current_cell_code;
          }
          
          return updatedListing;
        }
        return listing;
      });

      const updatedOrder = {
        order_id: order.order_id,
        shop_id: order.shop_id,
        listings: updatedListings,
        perform_by_team: 'FULFILL'
      };

      try {
        console.log('Updating order with:', updatedOrder);
        await this.props.updateOrders([updatedOrder]);
        this.loadOrders();
        this.handleShowToast(`Listing availability updated successfully`);
      } catch (error) {
        console.error('Error updating available status:', error);
        this.handleShowToast('Failed to update available status', 'danger');
      }
    }
  };

  getAvailableStatusInfo = (status) => {
    const statusMap = {
      '-1': { color: 'secondary', text: 'TEXT_AVAILABLE_PENDING' },
      0: { color: 'danger', text: 'TEXT_AVAILABLE_OUT_OF_STOCK' },
      1: { color: 'success', text: 'TEXT_AVAILABLE_IN_STOCK' },
      2: { color: 'warning', text: 'TEXT_AVAILABLE_RESERVED' }
    };
    return statusMap[status] || { color: 'secondary', text: 'TEXT_AVAILABLE_UNKNOWN' };
  };

  // Add function to get orders that need to be fulfilled
  getOrdersToFulfill = () => {
    const { orders } = this.props;
    return orders.filter(order => {
      // Chỉ lấy đơn có status 10, 11, 12
      return [10, 11, 12].includes(order.status);
    });
  };

  // Add function to handle fulfill label button click
  handleFulfillLabelClick = () => {
    console.log('Fulfill Label clicked');
    this.setState({ showFulfillLabelModal: true }, () => {
      console.log('Modal state updated:', this.state.showFulfillLabelModal);
    });
  };

  handleShowToast = (message, variant = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastVariant: variant
    });
    // Auto hide after 3 seconds
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  handlePrint = (type) => {
    const printWindow = window.open('', '_blank');
    const { orders = [] } = this.props;
    const ordersToFulfill = this.getOrdersToFulfill();

    if (type === 'shipping') {
      const shippableOrders = ordersToFulfill.filter(order =>
        order.listings.some(listing => listing.available === 1 || listing.available === 2)
      );
      // Định dạng ngày trước khi render HTML
      const rows = shippableOrders.map(order =>
        order.listings
          .filter(listing => listing.available === 1 || listing.available === 2)
          .map(listing => `
            <tr>
              <td>${require('moment')(order.order_date).format('DD/MM/YYYY')}</td>
              <td>${this.formatMonthlyIdToHuman(order.monthly_id) || '-'}</td>
              <td>${order.order_id}</td>
              <td>${order.shop_name}</td>
              <td>${order.customer_name}</td>
              <td>${listing.sku}</td>
              <td>
                <img src="${listing.img_url?.replace("75x75", "120x120")}" alt="${listing.title || ''}" class="product-image" />
              </td>
              <td>${listing.title?.length > 40 ? `${listing.title.substring(0, 40)}...` : listing.title || '-'}</td>
              <td>${listing.size || '-'}</td>
              <td>${order.buyer_note || '-'}</td>
              <td>${order.seller_note || '-'}</td>
              <td>${order.shipping_address || '-'}</td>
              <td>${listing.current_cell_code || '-'}</td>
              <td>${order.ioss || '-'}</td>
              <td style={{ whiteSpace: 'nowrap' }}>${order.shipping_center_date ? moment(order.shipping_center_date).format('DD/MM/YYYY HH:mm') : '-'}</td>
            </tr>
          `).join('')
      ).join('');
      printWindow.document.write(`
        <html>
          <head>
            <title>${getTranslate(LANGUAGE_KEYS.TEXT_SHIPPABLE_ORDERS)}</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              .product-image { width: 150px; height: 150px; object-fit: cover; display: block; margin: 0 auto; }
              @media print { .product-image { max-width: 150px; max-height: 150px; } }
            </style>
          </head>
          <body>
            <h2>${getTranslate(LANGUAGE_KEYS.TEXT_SHIPPABLE_ORDERS)}</h2>
            <div><strong>${getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ORDERS)}: ${shippableOrders.length}</strong></div>
            <table>
              <thead>
                <tr>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_ORDER_ID)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SHOP)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_NAME)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_USER_NOTE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_ADDRESS)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SHIPPING_CENTER_DATE)}</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>
          </body>
        </html>
      `);
    } else if (type === 'warehouse' || type === 'outofstock') {
      // Group by SKU, Size, and Cell Code
      const groupedOrders = {};
      ordersToFulfill.forEach(order => {
        order.listings
          .filter(listing => type === 'warehouse' ? (listing.available === 1 || listing.available === 2) : listing.available === 0)
          .forEach(listing => {
            const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
            if (!groupedOrders[key]) {
              groupedOrders[key] = {
                sku: listing.sku,
                size: listing.size,
                quantity: 0,
                cell: listing.current_cell_code,
                monthlyIds: new Set()
              };
            }
            groupedOrders[key].quantity += 1;
            groupedOrders[key].monthlyIds.add(order.monthly_id);
          });
      });
      const sortedOrders = Object.values(groupedOrders).sort((a, b) => {
        if (a.sku === b.sku) {
          return (a.size || '').localeCompare(b.size || '');
        }
        return a.sku.localeCompare(b.sku);
      });
      const totalLamps = sortedOrders.reduce((sum, item) => sum + item.quantity, 0);
      const rows = sortedOrders.map(item => `
        <tr>
          <td>${item.sku}</td>
          <td>${item.size}</td>
          <td>${item.quantity}</td>
          <td>${item.cell || '-'}</td>
          <td>${Array.from(item.monthlyIds).map(id => this.formatMonthlyIdToHuman(id)).join(', ')}</td>
        </tr>
      `).join('');

      printWindow.document.write(`
        <html>
          <head>
            <title>${getTranslate(type === 'warehouse' ? LANGUAGE_KEYS.TEXT_WAREHOUSE_LAMPS : LANGUAGE_KEYS.TEXT_OUT_OF_STOCK_LAMPS)}</title>
            <style>
              body { font-family: Arial, sans-serif; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f5f5f5; }
              .total { font-weight: bold; margin-top: 10px; }
            </style>
          </head>
          <body>
            <h2>${getTranslate(type === 'warehouse' ? LANGUAGE_KEYS.TEXT_WAREHOUSE_LAMPS : LANGUAGE_KEYS.TEXT_OUT_OF_STOCK_LAMPS)}</h2>
            <div class="total">${getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_LAMPS)}: ${totalLamps}</div>
            <table>
              <thead>
                <tr>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                  <th>${getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>
          </body>
        </html>
      `);
    } else if (type === 'allfulfill') {
      // Print all orders to fulfill (one row per order)
      const rows = ordersToFulfill.map(order => {
        const firstListing = order.listings[0] || {};
        const formattedMonthlyId = this.formatMonthlyIdToHuman(order.monthly_id);
        const qrContent = `https://qr-to.site/r/ksc/o/${formattedMonthlyId}`;
        // Render SVG QR code as string
        const qrSVG = ReactDOMServer.renderToStaticMarkup(
          <QRCode value={qrContent} size={96} />
        );
        return `
          <tr>
            <td>${order.shop_name || '-'}</td>
            <td>${formattedMonthlyId || '-'}</td>
            <td>${order.customer_name || '-'}</td>
            <td><b>${firstListing.sku || '-'}</b></td>
            <td><b>${firstListing.size || '-'}</b></td>
            <td style='text-align:center;'>${qrSVG}</td>
          </tr>
        `;
      }).join('');
      printWindow.document.write(`
        <html>
          <head>
            <title>All Orders to Fulfill</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-size: 36px; }
              td { font-size: 28px; height: 180px; text-align: center; }
              tr { height: 150px; }
              b { font-weight: bold; }
            </style>
          </head>
          <body>
            <table>
              <tbody>
                ${rows}
              </tbody>
            </table>
          </body>
        </html>
      `);
    }
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  handleAddOrder = () => {
    this.setState({ 
      showAddOrderModal: true,
      newOrderForm: {
        shop_name: '',
        customer_name: '',
        email: '',
        shipping_address: '',
        buyer_note: '',
        seller_note: '',
        priority: 2,
        added_reason: 'ETSY_WARRANTY_ORDER',
        reference_code: '',
        order_date: new Date(), // Reset to current date
        listings: [{
          sku: '',
          size: '',
          title: '',
          img_url: ''
        }]
      }
    });
  };

  handleNewOrderFormChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'reference_code') {
      // Update seller note with reference code
      const referenceNote = value ? `[Reference: ${value}]\n` : '';
      this.setState(prevState => ({
        newOrderForm: {
          ...prevState.newOrderForm,
          reference_code: value,
          seller_note: referenceNote + (prevState.newOrderForm.seller_note.replace(/^\[Reference:.*?\]\n/, '') || '')
        }
      }));
    } else if (name === 'seller_note') {
      // Preserve reference code when updating seller note
      const referenceCode = prevState.newOrderForm.reference_code;
      const referenceNote = referenceCode ? `[Reference: ${referenceCode}]\n` : '';
      this.setState(prevState => ({
        newOrderForm: {
          ...prevState.newOrderForm,
          seller_note: referenceNote + value
        }
      }));
    } else if (name === 'order_date') {
      // Handle date change
      this.setState(prevState => ({
        newOrderForm: {
          ...prevState.newOrderForm,
          order_date: value
        }
      }));
    } else if (name === 'customer_name' && value === 'Sign in with Apple user') {
      // If customer name is "Sign in with Apple user", use first line of shipping address
      const shippingAddress = this.state.newOrderForm.shipping_address;
      const firstLine = shippingAddress ? shippingAddress.split('\n')[0] : '';
      this.setState(prevState => ({
        newOrderForm: {
          ...prevState.newOrderForm,
          customer_name: firstLine || value // Use first line if available, otherwise keep original value
        }
      }));
    } else {
      this.setState(prevState => ({
        newOrderForm: {
          ...prevState.newOrderForm,
          [name]: value
        }
      }));
    }
  };

  handleNewOrderListingChange = (index, field, value) => {
    this.setState(prevState => {
      const newListings = [...prevState.newOrderForm.listings];
      if (field === 'product') {
        newListings[index] = {
          ...newListings[index],
          product_code: value ? value.value : '',
          sku: value ? value.sku_code : '',
          size: value ? value.size : '',
          title: value ? value.product_name : '',
          img_url: value ? value.img_url : ''
        };
        console.log('DEBUG chọn sản phẩm:', {
          product_code: value ? value.value : '',
          option: value
        });
      } else {
        newListings[index] = {
          ...newListings[index],
          [field]: value
        };
      }
      return {
        newOrderForm: {
          ...prevState.newOrderForm,
          listings: newListings
        }
      };
    });
  };

  handleAddNewOrder = () => {
    const { newOrderForm } = this.state;
    // Generate order_id nếu chưa có
    const generatedOrderId = newOrderForm.order_id || ('ODR' + Date.now());
    const orderPayload = {
      ...newOrderForm,
      order_id: generatedOrderId,
      order_date: newOrderForm.order_date.toISOString(), // Convert Date to ISO string
      status: 2,
      perform_by_team: this.getPerformByTeam()
    };

    this.props.updateOrders([orderPayload])
      .then(() => {
        this.setState({ showAddOrderModal: false });
        this.loadOrders();
        this.handleShowToast('Order added successfully');
      })
      .catch(error => {
        console.error('Error adding order:', error);
        this.handleShowToast('Failed to add order', 'danger');
      });
  };

  handleShopNameChange = (newValue) => {
    if (newValue && !this.state.shopOptions.find(option => option.value === newValue.value)) {
      this.setState(prevState => ({
        shopOptions: [...prevState.shopOptions, newValue]
      }));
    }
    this.setState(prevState => ({
      newOrderForm: {
        ...prevState.newOrderForm,
        shop_name: newValue ? newValue.value : ''
      }
    }));
  };

  handleExportSGB = async () => {
    // Get filteredOrders như trong render
    const filteredOrders = (this.props.orders || []).filter(order => !order.is_deleted);
    if (filteredOrders.length === 0) {
      this.handleShowToast('Không có đơn nào để gửi SGB!', 'warning');
      return;
    }
    
    // Lấy tất cả monthly_ids từ các đơn hàng đã lọc
    const monthly_ids = filteredOrders.map(order => order.monthly_id).filter(id => id);
    
    if (monthly_ids.length === 0) {
      this.handleShowToast('Không có monthly_id hợp lệ để gửi SGB!', 'warning');
      return;
    }
    
    try {
      // Tạo URL với monthly_ids dưới dạng chuỗi phân tách bằng dấu phẩy
      const monthly_ids_string = monthly_ids.join(',');
      
      // Lấy token từ localStorage
      const token = getToken();
      if (!token) {
        this.handleShowToast('Không tìm thấy token đăng nhập!', 'danger');
        return;
      }
      
      const res = await fetch(`${getApiUrl()}/api/order/export-data-sgb?monthly_ids=${monthly_ids_string}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const result = await res.json();
      if (result.status === 1 && result.data && result.data.sheetUrl) {
        window.open(result.data.sheetUrl, '_blank');
        this.handleShowToast('Đã gửi yêu cầu và mở Google Sheet SGB!');
      } else {
        this.handleShowToast(result.message || 'Đã gửi yêu cầu cập nhật Google Sheet cho SGB!');
      }
    } catch (err) {
      this.handleShowToast('Gửi SGB thất bại!', 'danger');
    }
  };

  handleExportViettelPost = async () => {
    // Get filteredOrders như trong render
    const filteredOrders = (this.props.orders || []).filter(order => !order.is_deleted);
    if (filteredOrders.length === 0) {
      this.handleShowToast('Không có đơn nào để gửi Viettel Post!', 'warning');
      return;
    }
    
    // Lấy tất cả monthly_ids từ các đơn hàng đã lọc
    const monthly_ids = filteredOrders.map(order => order.monthly_id).filter(id => id);
    
    if (monthly_ids.length === 0) {
      this.handleShowToast('Không có monthly_id hợp lệ để gửi Viettel Post!', 'warning');
      return;
    }
    
    try {
      // Tạo URL với monthly_ids dưới dạng chuỗi phân tách bằng dấu phẩy
      const monthly_ids_string = monthly_ids.join(',');
      
      const res = await fetch(`${getApiUrl()}/api/order/export-data-viettel-post?monthly_ids=${monthly_ids_string}`);
      const result = await res.json();
      if (result.status === 1 && result.data && result.data.sheetUrl) {
        window.open(result.data.sheetUrl, '_blank');
        this.handleShowToast('Đã gửi yêu cầu và mở Google Sheet Viettel Post!');
      } else {
        this.handleShowToast(result.message || 'Đã gửi yêu cầu cập nhật Google Sheet cho Viettel Post!');
      }
    } catch (err) {
      this.handleShowToast('Gửi Viettel Post thất bại!', 'danger');
    }
  };

  handleBuyerNoteEdit = (orderId) => {
    this.setState({
      editingBuyerNote: orderId,
      buyerNoteValue: this.props.orders.find(o => o.order_id === orderId)?.buyer_note || ''
    });
  };

  handleBuyerNoteChange = (e) => {
    this.setState({ buyerNoteValue: e.target.value });
  };

  handleBuyerNoteSave = (orderId) => {
    const order = this.props.orders.find(o => o.order_id === orderId);
    if (order) {
      const updatedOrder = {
        order_id: order.order_id,
        shop_id: order.shop_id,
        buyer_note: this.state.buyerNoteValue,
        perform_by_team: this.getPerformByTeam()
      };
      this.props.updateOrders([updatedOrder], { isUpdated: true })
        .then(() => {
          this.setState({ editingBuyerNote: null });
        })
        .catch(error => {
          console.error('Error updating buyer note:', error);
          alert("Failed to update buyer note. See console for details.");
        });
    }
  };

  handleCreateMonthlyId = async () => {
    try {
      const res = await axios.get(`${getApiUrl()}/api/order/create-monthly-id`);
      if (res.data && res.data.status === 1) {
        this.handleShowToast('Tạo mã đơn thành công!');
        this.loadOrders();
      } else {
        this.handleShowToast(res.data?.message || 'Tạo mã đơn thất bại!', 'danger');
      }
    } catch (err) {
      this.handleShowToast('Tạo mã đơn thất bại!', 'danger');
    }
  };

  // Thêm hàm formatMonthlyIdToHuman
  formatMonthlyIdToHuman = (monthlyId) => {
    if (!monthlyId || typeof monthlyId !== 'string' || monthlyId.length < 7) return monthlyId;
    // Lấy tháng
    const month = parseInt(monthlyId.substring(2, 4), 10);
    // Lấy số thứ tự (bỏ các số 0 đầu)
    const orderNum = parseInt(monthlyId.substring(4), 10);
    if (isNaN(month) || isNaN(orderNum)) return monthlyId;
    return `T${month}.${orderNum}`;
  };

  // Hàm mở modal edit listing (chỉ sửa sản phẩm)
  handleEditListingOnly = (order, listing, index) => {
    // Tìm product_code từ danh sách sản phẩm dựa vào sku + size
    const { products = [] } = this.props;
    let product_code = '';
    if (listing.sku && listing.size) {
      const found = products.find(
        p => p.sku_code === listing.sku && p.size === listing.size
      );
      if (found) product_code = found.product_code;
    }

    this.setState({
      showEditModal: true,
      currentOrder: order,
      currentListing: {
        ...listing,
        product_code // Gán product_code tạm vào currentListing để dropdown nhận biết
      },
      currentListingIndex: index,
      editForm: {
        sku: listing.sku,
        size: listing.size,
        title: listing.title,
        product_code: product_code || '', // Thêm product_code vào editForm
        quantity: listing.quantity || 1,
      },
      editMode: 'listing',
      currentListingIndex: index,
      isAddingListing: false
    });
  };

  // Hàm mở modal edit order (chỉ sửa thông tin khách hàng, ghi chú)
  handleEditOrderOnly = (order) => {
    this.setState({
      showEditModal: true,
      currentOrder: order,
      editForm: {
        customer_name: order.customer_name || '',
        email: order.email || '',
        shipping_address: order.shipping_address || '',
        buyer_note: order.buyer_note || '',
        seller_note: order.seller_note || '',
        priority: order.priority || 2,
        ioss: order.ioss || '',
        order_date: order.order_date ? new Date(order.order_date) : new Date(),
      },
      editMode: 'order',
      editListingIndex: null,
      isAddingListing: false
    });
  };

  handleShowExportModal = () => {
    // Lấy danh sách order được chọn
    const { orders = [] } = this.props;
    const selectedOrderIds = Array.from(this.state.selectedOrders);
    const selectedOrders = orders.filter(order => selectedOrderIds.includes(order.order_id));
    // Gộp các listing theo sku, size (và tạo product_code = `${sku}-${size}`)
    const productMap = {};
    selectedOrders.forEach(order => {
      (order.listings || []).forEach(listing => {
        const sku = listing.sku || '';
        const size = listing.size || '';
        const product_code = sku && size ? `${sku}-${size}` : sku || '';
        const key = `${product_code}__${sku}__${size}`;
        if (!productMap[key]) {
          productMap[key] = {
            product_code,
            sku,
            size,
            quantity: 0,
            orderIds: {}
          };
        }
        productMap[key].quantity += (listing.quantity || 1);
        if (order.monthly_id) {
          if (!productMap[key].orderIds[order.monthly_id]) {
            productMap[key].orderIds[order.monthly_id] = 0;
          }
          productMap[key].orderIds[order.monthly_id] += (listing.quantity || 1);
        }
      });
    });
    // Convert orderIds object to array of {monthly_id, count}
    let exportItems = Object.values(productMap).map(item => ({
      ...item,
      orderIds: Object.entries(item.orderIds).map(([monthly_id, count]) => ({ monthly_id, count }))
    }));
    // Sort SKU A-Z, size theo M-L-XL-XXL
    const sizeOrder = { 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4 };
    exportItems = exportItems.sort((a, b) => {
      if (a.sku === b.sku) {
        return (sizeOrder[a.size] || 0) - (sizeOrder[b.size] || 0);
      }
      return (a.sku || '').localeCompare(b.sku || '');
    });
    this.setState({
      showExportModal: true,
      exportItems,
      exportWarehouse: '',
      exportNote: '',
      exportSaving: false
    });
  };

  handleExportSubmit = async () => {
    const { exportWarehouse, exportItems, exportNote, exportSaving } = this.state;
    if (!exportWarehouse || exportSaving) return;
    this.setState({ exportSaving: true });
    try {
      // Kiểm tra và yêu cầu load lại danh sách sản phẩm nếu chưa có
      if (!this.props.products || this.props.products.length === 0) {
        await this.props.getSIVProductList();
        // Kiểm tra lại sau khi load
        if (!this.props.products || this.props.products.length === 0) {
          this.handleShowToast('Không thể load danh sách sản phẩm. Vui lòng thử lại sau.', 'danger');
          this.setState({ exportSaving: false });
          return;
        }
      }

      // Tính system_note là danh sách monthly_id chuẩn, phân tách bằng dấu phẩy
      const allOrderIds = exportItems.flatMap(item => item.orderIds.map(oid => oid.monthly_id));
      const uniqueOrderIds = Array.from(new Set(allOrderIds));
      const system_note = uniqueOrderIds.join(',');
      // Gọi API xuất hàng
      await this.props.setSIVProductInventoryTransaction({
        type: 'EXPORT',
        partner_id: exportWarehouse,
        staff_note: exportNote,
        system_note,
        items: exportItems.map(item => {
          const product = (this.props.products || []).find(p => p.product_code === item.product_code);
          const current_qty = product ? (product.current_qty || 0) : 0;
          const quantity_change = -item.quantity;
          const quantity = product ? (current_qty + quantity_change) : undefined;
          return {
            product_code: item.product_code,
            quantity_change,
            quantity,
            warehouse_id: 1,
            warehouse_cell_code: product ? (product.current_cell_code || '') : ''
          };
        })
      });
      // Update trạng thái các order được chọn sang 13 (was 12)
      const selectedOrderIds = Array.from(this.state.selectedOrders);
      const ordersToUpdate = selectedOrderIds.map(order_id => ({
        order_id,
        status: 13, // chuyển sang 13
        perform_by_team: 'FULFILL'
      }));
      await this.props.updateOrders(ordersToUpdate);
      this.setState({ showExportModal: false, exportSaving: false });
      this.loadOrders();
      this.handleShowToast('Xuất hàng và cập nhật trạng thái thành công!');
    } catch (err) {
      this.setState({ exportSaving: false });
      this.handleShowToast('Lỗi khi xuất hàng hoặc cập nhật trạng thái!', 'danger');
    }
  };

  // Add function to get shortened shop name
  getShortenedShopName = (shopName) => {
    switch (shopName) {
      case 'ResinEpic':
        return 'EPIC';
      case 'GiftSymphony':
        return 'GIFT';
      case 'GiftArtbyAnna':
        return 'ANNA';
      default:
        return shopName;
    }
  };

  handlePrintDebtOrders = () => {
    const { orders = [] } = this.props;
    const { selectedOrders } = this.state;
    
    const selectedDebtOrders = orders.filter(order => 
      selectedOrders.has(order.order_id)
    );
    
    if (selectedDebtOrders.length === 0) {
      this.handleShowToast('Không có đơn nợ nào được chọn', 'warning');
      return;
    }

    const printWindow = window.open('', '_blank');
    
    // Format orders for printing
    const rows = selectedDebtOrders.map(order => {
      const firstListing = order.listings[0] || {};
      const formattedMonthlyId = this.formatMonthlyIdToHuman(order.monthly_id);
      const qrContent = `https://qr-to.site/r/ksc/o/${formattedMonthlyId}`;
      // Render SVG QR code as string
      const qrSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCode value={qrContent} size={96} />
      );

      // Get recipient name from first line of shipping address
      const recipientName = order.shipping_address ? 
        order.shipping_address.split('\n')[0].trim() : 
        '-';

      // Get shortened shop name
      const shortenedShopName = this.getShortenedShopName(order.shop_name);

      return `
        <tr>
          <td>${shortenedShopName || '-'}</td>
          <td>${formattedMonthlyId || '-'}</td>
          <td>${recipientName}</td>
          <td><b>${firstListing.sku || '-'}</b></td>
          <td><b>${firstListing.size || '-'}</b></td>
          <td style='text-align:center;'>${qrSVG}</td>
        </tr>
      `;
    }).join('');

    printWindow.document.write(`
      <html>
        <head>
          <title>In Mã Đơn Nợ</title>
          <style>
            @page {
              margin: 0;
              padding: 0;
            }
            body {
              margin: 0;
              padding: 0;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin: 0;
              padding: 0;
            }
            td { 
              border: 1px solid #ddd; 
              padding: 8px; 
              text-align: left; 
              font-size: 28px; 
              height: 180px; 
              text-align: center; 
            }
            tr { height: 150px; }
            b { font-weight: bold; }
          </style>
        </head>
        <body>
          <table>
            <tbody>
              ${rows}
            </tbody>
          </table>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  handlePrintOrderDetails = () => {
    const { orders = [] } = this.props;
    const selectedOrderIds = Array.from(this.state.selectedOrders);
    const selectedOrders = orders.filter(order => selectedOrderIds.includes(order.order_id));

    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Please allow popups for this website');
      return;
    }

    // Table headers
    const headers = [
      'NGÀY ĐẶT HÀNG',
      'MÃ ĐƠN',
      'SHOP',
      'KHÁCH HÀNG',
      'MÃ SKU',
      'ẢNH',
      'TÊN SẢN PHẨM',
      'KÍCH CỠ',
      'GHI CHÚ KHÁCH',
      'GHI CHÚ NHÂN VIÊN'
    ];

    // Build table rows with rowspan for shared order info
    const rows = selectedOrders.map(order => {
      const listings = order.listings || [];
      const rowSpan = listings.length;
      return listings.map((listing, idx) => {
        // Limit product name to 20 characters
        const shortTitle = listing.title && listing.title.length > 20 ? listing.title.substring(0, 20) + '…' : (listing.title || '-');
        return `
          <tr>
            ${idx === 0 ? `<td rowspan="${rowSpan}">${order.order_date ? moment(order.order_date).format('DD/MM/YYYY') : '-'}</td>` : ''}
            ${idx === 0 ? `<td rowspan="${rowSpan}">${this.formatMonthlyIdToHuman(order.monthly_id) || '-'}</td>` : ''}
            ${idx === 0 ? `<td rowspan="${rowSpan}">${order.shop_name || '-'}</td>` : ''}
            ${idx === 0 ? `<td rowspan="${rowSpan}">${order.customer_name || '-'}</td>` : ''}
            <td>${listing.sku || '-'}</td>
            <td>${listing.img_url ? `<img src="${listing.img_url.replace('75x75','120x120')}" style="max-width:100px;max-height:100px;object-fit:cover;" />` : '-'}</td>
            <td>${shortTitle}</td>
            <td>${listing.size || '-'}</td>
            ${idx === 0 ? `<td rowspan="${rowSpan}">${order.buyer_note ? order.buyer_note : '-'}</td>` : ''}
            ${idx === 0 ? `<td rowspan="${rowSpan}">${order.seller_note ? order.seller_note : '-'}</td>` : ''}
          </tr>
        `;
      }).join('');
    }).join('');

    // Print content
    const printContent = `
      <html>
        <head>
          <title>Chi tiết đơn hàng</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #bbb; padding: 8px; text-align: center; vertical-align: middle; }
            th { background: #f5f5f5; }
            img { display: block; margin: 0 auto; }
            td[style*='white-space:pre-line;'] { text-align: left; }
          </style>
        </head>
        <body>
          <table>
            <thead>
              <tr>
                ${headers.map(h => `<th>${h}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${rows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleScrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  // Thêm hàm helper vào class OrderList
  getDisplayCustomerName = (order) => {
    if (order.customer_name === 'Sign in with Apple user') {
      if (order.shipping_address) {
        const firstLine = order.shipping_address.split('\n')[0].trim();
        return firstLine || order.customer_name;
      }
    }
    return order.customer_name;
  };

  render() {
    const { 
      loading, 
      dateFilter, 
      selectedOrders, 
      showEditModal, 
      editForm, 
      showConfigModal, 
      columnVisibility,
      showScanOrdersModal,
      currentPage,
      itemsPerPage,
      totalCount,
      selectedBulkStatus,
      showRndDoneModal,
      rndNoteValue,
      rndOrderId,
      sortBy,
      sortOrder,
      shopFilter,
      statusFilter,
      keyword,
      showLogModal,
      currentOrderLogs,
      isShowLatestLog,
      isShowSystemInfo,
      currentOrderForLog,
      logPagination,
      showWarehouseModal,
      showFulfillLabelModal,
      showAddOrderModal,
      newOrderForm,
      showExportModal,
      exportWarehouse,
      exportItems,
      exportNote,
      exportSaving,
      editingBuyerNote,
      buyerNoteValue
    } = this.state;
    const { orders = [], products = [], targetPage: propsTargetPage } = this.props;
    const targetPage = propsTargetPage || this.state.targetPage;

    // Create a map of valid SKUs and their valid sizes
    const validSkuMap = new Map();
    console.log('DEBUG products before mapping:', products);
    if (products && products.length > 0) {
      products.forEach(product => {
        console.log('DEBUG processing product:', product);
        const parts = product.product_code.split('-');
        const sku = parts.slice(0, -1).join('-'); // Get all parts except the last one
        console.log('DEBUG extracted SKU:', sku, 'from product_code:', product.product_code);
        if (!validSkuMap.has(sku)) {
          validSkuMap.set(sku, new Set());
        }
        validSkuMap.get(sku).add(product.size);
      });
    } else {
      console.log('DEBUG: No products data available');
      // Try to reload products if not available and not already attempted
      if ((!this.props.products || this.props.products.length === 0) && !this.state.productListLoaded) {
        console.log('DEBUG: Attempting to reload products (first time only)');
        this.setState({ productListLoaded: true }); // Set flag to prevent multiple calls
        this.props.getSESProducts({ currentPage: 1, itemsPerPage: 9999, sortBy: 'product_code', sortOrder: 1 });
      }
    }

    console.log('DEBUG validSkuMap:', Array.from(validSkuMap.entries()));

    const skuOptions = products.map(product => ({
      value: product.sku_code,
      label: `${product.sku_code} - ${product.product_name}`
    }));

    const ordersToFulfill = this.getOrdersToFulfill();
    console.log('Orders to fulfill:', ordersToFulfill);

    const productOptions = (products || []).map(product => ({
      value: product.product_code,
      label: `${product.product_code} - ${product.product_name}`,
      img_url: product.images && product.images.length > 0
        ? product.images[0].image_link
        : '',
      product_name: product.product_name,
      sku_code: product.sku_code,
      size: product.size
    }));

    // Chuẩn bị map monthly_id -> màu (2 màu xen kẽ)
    const monthlyIdColorMap = {};
    let colorIdx = 0;
    const rowColors = ['#f3f3f3', '#e9f0fa']; // Trắng và xanh nhạt, dễ phân biệt hơn
    orders.forEach(order => {
      if (order.monthly_id && !(order.monthly_id in monthlyIdColorMap)) {
        monthlyIdColorMap[order.monthly_id] = colorIdx % 2;
        colorIdx++;
      }
    });

    // Thêm hàm kiểm tra xem có đơn nợ nào được chọn không
    const hasSelectedDebtOrders = () => {
      if (targetPage !== 'fulfill' || selectedOrders.size === 0) return false;
      return Array.from(selectedOrders).some(orderId => {
        const order = orders.find(o => o.order_id === orderId);
        return order && order.status === 10;
      });
    };

    return (
      <Container fluid>
        <Toast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          delay={3000}
          autohide
          style={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 9999
          }}
          bg={this.state.toastVariant}
          text="white"
        >
          <Toast.Header closeButton>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{this.state.toastMessage}</Toast.Body>
        </Toast>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="text-center mb-0">{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_LIST)}</h2>
          <div className="d-flex gap-2">
            {targetPage === 'sale' && (
              <>
                <Button variant="warning" className="me-2" onClick={this.handleCreateMonthlyId}>
                  Tạo mã đơn
                </Button>
                <Button variant="success" className="me-2" onClick={this.handleExportSGB}>
                  Gửi SGB
                </Button>
                <Button variant="info" onClick={this.handleExportViettelPost}>
                  Gửi Viettel Post
                </Button>
                <Button variant="primary" onClick={this.handleAddOrder}>
                  {getTranslate(LANGUAGE_KEYS.TEXT_ADD_ORDER)}
                </Button>
                <Button variant="info" onClick={() => this.setState({ showWarehouseModal: true })}>
                  {getTranslate(LANGUAGE_KEYS.TEXT_VIEW_WAREHOUSE)}
                </Button>
              </>
            )}
            {targetPage === 'fulfill' && (
              <>
                {this.state.statusFilter === '12' && this.state.selectedOrders.size > 0 && (
                  <Button variant="danger" className="me-2" onClick={this.handleShowExportModal}>
                    Xuất hàng
                  </Button>
                )}
                <Button variant="warning" onClick={this.handleAutoFulfill}>
                  Auto Fulfill
                </Button>
                <Button variant="info" onClick={() => this.setState({ showWarehouseModal: true })}>
                  {getTranslate(LANGUAGE_KEYS.TEXT_VIEW_WAREHOUSE)}
                </Button>
                <Button variant="success" onClick={this.handleFulfillLabelClick}>
                  Fulfill Label
                </Button>
              </>
            )}
          </div>
        </div>

        <Row className="mb-3">
          <Col md={3}>
            <FormSelect
              value={dateFilter}
              onChange={this.handleDateFilterChange}
              className="mb-2"
            >
              <option value="today">{getTranslate(LANGUAGE_KEYS.TEXT_TODAY)}</option>
              <option value="yesterday">{getTranslate(LANGUAGE_KEYS.TEXT_YESTERDAY)}</option>
              <option value="this_week">{getTranslate(LANGUAGE_KEYS.TEXT_THIS_WEEK)}</option>
              <option value="last_week">{getTranslate(LANGUAGE_KEYS.TEXT_LAST_WEEK)}</option>
              <option value="this_month">{getTranslate(LANGUAGE_KEYS.TEXT_THIS_MONTH)}</option>
              <option value="last_month">{getTranslate(LANGUAGE_KEYS.TEXT_LAST_MONTH)}</option>
              <option value="all">{getTranslate(LANGUAGE_KEYS.TEXT_ALL)}</option>
            </FormSelect>
          </Col>
          <Col md={3}>
            <FormSelect
              value={this.state.shopFilter}
              onChange={this.handleShopFilterChange}
              className="mb-2"
            >
              <option value="All">Tất cả shop</option>
              <option value="ResinEpic">ResinEpic</option>
              <option value="GiftSymphony">GiftSymphony</option>
              <option value="GiftArtbyAnna">GiftArtbyAnna</option>
            </FormSelect>
          </Col>
          <Col md={3}>
            <FormSelect
              value={this.state.statusFilter}
              onChange={this.handleStatusFilterChange}
              className="mb-2"
            >
              <option value="">Tất cả trạng thái</option>
              {(() => {
                const statusListFilter = this.state.targetPage === 'sale'
                  ? [0,1,2,3,4,10,11,12,13,20,21,22,23,24,30,31]
                  : this.state.targetPage === 'fulfill'
                    ? [10,11,12,13,20,21,22,23,24,30,31]
                    : [];
                return statusListFilter.map(stt => (
                  <option key={stt} value={stt}>
                    [{stt}] {getTranslate(LANGUAGE_KEYS[`TEXT_${this.getOrderStatusInfo(stt).text}`])}
                  </option>
                ));
              })()}
            </FormSelect>
          </Col>
          <Col md={3}>
            <div className="position-relative">
              <Form.Control
                type="text"
                placeholder="Tìm kiếm..."
                value={this.state.keyword}
                onChange={this.handleKeywordChange}
                onBlur={this.handleKeywordSearch}
                onKeyDown={this.handleKeywordSearch}
                className="mb-2 pe-5"
              />
              {this.state.keyword && (
                <span
                  style={{
                    position: 'absolute',
                    right: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#888',
                    fontSize: 18,
                    zIndex: 2
                  }}
                  onClick={() => {
                    localStorage.setItem(`orderKeyword_${this.state.targetPage}`, '');
                    this.setState({ keyword: '', currentPage: 1 }, () => {
                      this.updateURL({ keyword: '', page: 1 });
                      this.loadOrders();
                    });
                  }}
                  title="Xóa tìm kiếm"
                >
                  ×
                </span>
              )}
            </div>
          </Col>
        </Row>
        {this.isFeatureEnabled('bulk_update') && (
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <FormSelect
                value={selectedBulkStatus}
                onChange={this.handleBulkStatusChange}
                className="me-2"
                style={{ width: 'auto' }}
              >
                <option value="">{getTranslate(LANGUAGE_KEYS.TEXT_BULK_UPDATE_STATUS)}</option>
                {this.getAvailableStatuses().map((status) => (
                  <option key={status.value} value={status.value}>
                    [{status.value}] {getTranslate(LANGUAGE_KEYS[`TEXT_${status.text}`])}
                  </option>
                ))}
              </FormSelect>
              <Button
                variant="primary"
                size="sm"
                onClick={this.handleBulkStatusApply}
                disabled={!selectedBulkStatus || selectedOrders.size === 0}
                style={{
                  '&:disabled': {
                    color: '#6c757d !important',
                    backgroundColor: '#e9ecef !important',
                    borderColor: '#dee2e6 !important'
                  }
                }}
              >
                <span style={{ 
                  color: (!selectedBulkStatus || selectedOrders.size === 0) ? '#6c757d' : 'inherit'
                }}>
                  {getTranslate(LANGUAGE_KEYS.TEXT_APPLY)}
                </span>
              </Button>
              {targetPage === 'fulfill' && selectedOrders.size > 0 && (
                <Button 
                  variant="info"
                  size="sm"
                  className="ms-2"
                  onClick={this.handlePrintDebtOrders}
                  disabled={selectedOrders.size === 0}
                >
                  In Label Đơn
                </Button>
              )}
              {targetPage === 'fulfill' && selectedOrders.size > 0 && (
                <Button 
                  variant="info"
                  size="sm"
                  className="ms-2"
                  onClick={this.handlePrintOrderDetails}
                >
                  In Danh Sách Đơn
                </Button>
              )}
              <span className="text-muted ms-2">
                {selectedOrders.size} {getTranslate(LANGUAGE_KEYS.TEXT_ORDERS_SELECTED)}
              </span>
              <span className="ms-4 me-2">
                {getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ORDERS)}: <strong>{totalCount}</strong>
                &nbsp;&nbsp;
                {getTranslate(LANGUAGE_KEYS.TEXT_SHOWING)}: <strong>{orders.length}</strong>
              </span>
            </div>
            <div className="d-flex align-items-center">
              <Button
                variant="secondary"
                size="sm"
                onClick={this.handleConfigToggle}
                className="me-4"
              >
                {getTranslate(LANGUAGE_KEYS.TEXT_CONFIG_VIEW)}
                {this.state.stickHeader && (
                  <span className="ms-2 badge bg-success" title="Sticky header enabled">
                    📌
                  </span>
                )}
              </Button>
              <span className="me-2">{getTranslate(LANGUAGE_KEYS.TEXT_ITEMS_PER_PAGE)}:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={this.handleItemsPerPageChange}
                style={{ width: 'auto' }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
              </Form.Select>
            </div>
          </div>
        )}

      
        {loading && (
          <div className="text-center mb-3">
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">{getTranslate(LANGUAGE_KEYS.TEXT_LOADING)}</span>
          </div>
        )}

        {!loading && orders.length === 0 && (
          <div className="text-center mb-3">
            <p>{getTranslate(LANGUAGE_KEYS.TEXT_NO_ORDERS_FOUND)}</p>
          </div>
        )}

        <Table bordered responsive size="sm" className={this.state.stickHeader ? 'table-sticky-header' : ''}>
          <style>{`
            th, td {
              max-width: 250px;
              word-break: break-word;
              white-space: pre-line;
            }
          `}</style>
          <thead>
            <tr>
              {targetPage !== 'rnd' && (
                <th>
                  <FormCheck
                    checked={selectedOrders.size > 0 && selectedOrders.size === orders.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.setState({
                          selectedOrders: new Set(orders.map(order => order.order_id))
                        });
                      } else {
                        this.setState({ selectedOrders: new Set() });
                      }
                    }}
                    disabled={orders.length === 0}
                  />
                </th>
              )}
              {columnVisibility.stt && <th style={{ width: 60, textAlign: 'center' }}>STT</th>}
              {columnVisibility.orderDate && <th>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</th>}
              {columnVisibility.monthlyId && <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('monthly_id')}>
                {getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}
                {this.state.sortBy === 'monthly_id' && (
                  <span>{this.state.sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                )}
              </th>}
              {columnVisibility.orderId && <th>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_ID)}</th>}
              {columnVisibility.shop && <th>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP)}</th>}
              {columnVisibility.customer && <th>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</th>}
              {columnVisibility.status && <th>{getTranslate(LANGUAGE_KEYS.TEXT_STATUS)}</th>}
              {columnVisibility.priority && <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('priority')}>
                {getTranslate(LANGUAGE_KEYS.TEXT_PRIORITY)}
                {this.state.sortBy === 'priority' && (
                  <span>{this.state.sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                )}
              </th>}
              {columnVisibility.sku && <th>{getTranslate(LANGUAGE_KEYS.TEXT_SKU_CODE)}</th>}
              {columnVisibility.image && <th>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>}
              {columnVisibility.title && <th>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)}</th>}
              {columnVisibility.size && <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('size')}>
                {getTranslate(LANGUAGE_KEYS.TEXT_SIZE)} {sortBy === 'size' && (sortOrder < 0 ? '↓' : '↑')}
              </th>}
              {columnVisibility.quantity && (
                <th onClick={() => this.handleSort('quantity')} style={{ cursor: 'pointer' }}>
                  {getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY) || 'Số lượng'} {sortBy === 'quantity' && (sortOrder < 0 ? '↓' : '↑')}
                </th>
              )}
              {columnVisibility.buyerNote && <th>{getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</th>}
              {columnVisibility.sellerNote && <th>{getTranslate(LANGUAGE_KEYS.TEXT_STAFF_NOTE)}</th>}
              {columnVisibility.estDelivery && <th>{getTranslate(LANGUAGE_KEYS.TEXT_EST_DELIVERY)}</th>}
              {columnVisibility.shippingAddress && <th>{getTranslate(LANGUAGE_KEYS.TEXT_SHIPPING_ADDRESS)}</th>}
              {columnVisibility.email && <th>{getTranslate(LANGUAGE_KEYS.TEXT_EMAIL)}</th>}
              {columnVisibility.ioss && <th>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</th>}
              {columnVisibility.available && <th>{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE)}</th>}
              {columnVisibility.shippingCenterDate && <th>{getTranslate(LANGUAGE_KEYS.TEXT_SHIPPING_CENTER_DATE)}</th>}
              {columnVisibility.action && <th>{getTranslate(LANGUAGE_KEYS.TEXT_ACTIONS)}</th>}
            </tr>
          </thead>
          <tbody>
            {/* Group orders by monthly_id for rowspan rendering */}
            {(() => {
              // Group orders by monthly_id
              const grouped = {};
              orders.forEach(order => {
                if (!grouped[order.monthly_id]) grouped[order.monthly_id] = [];
                grouped[order.monthly_id].push(order);
              });
              // Flatten to array of {order, listing, idxInGroup, groupSize}
              const rows = [];
              Object.values(grouped).forEach(orderGroup => {
                // Mỗi order trong group có thể có nhiều listing
                const groupSize = orderGroup.reduce((sum, o) => sum + o.listings.length, 0);
                let listingIdx = 0;
                orderGroup.forEach(order => {
                  order.listings.forEach((listing, idx) => {
                    rows.push({
                      order,
                      listing,
                      idxInGroup: listingIdx,
                      groupSize,
                      isFirst: listingIdx === 0
                    });
                    listingIdx++;
                  });
                });
              });
              // Đánh số thứ tự theo order, không theo listing
              let orderStt = (currentPage - 1) * itemsPerPage + 1;
              Object.values(grouped).forEach(orderGroup => {
                const firstRow = orderGroup[0];
                if (firstRow && firstRow.order) {
                  firstRow.order.__stt = orderStt++;
                }
              });
              return rows.map(({order, listing, idxInGroup, groupSize, isFirst}, rowIdx) => {
                const sku = listing.sku; // Use listing.sku directly
                const size = listing.size;
                const isSkuValid = validSkuMap.has(sku);
                const isSizeValid = size && validSkuMap.get(sku)?.has(size);

                return (
                  <tr key={`${order.order_id}-${listing.sku}-${idxInGroup}`}
                    style={{ backgroundColor: order.monthly_id ? rowColors[monthlyIdColorMap[order.monthly_id]] : undefined }}
                  >
                    {/* Checkbox chọn đơn */}
                    {targetPage !== 'rnd' && isFirst && (
                      <td rowSpan={groupSize}>
                        <FormCheck
                          checked={this.state.selectedOrders.has(order.order_id)}
                          onChange={() => this.handleOrderSelect(order.order_id)}
                        />
                      </td>
                    )}
                    {columnVisibility.stt && isFirst && (
                      <td rowSpan={groupSize} style={{ textAlign: 'center' }}>{orderStt++}</td>
                    )}
                    {/* Ngày đặt hàng */}
                    {columnVisibility.orderDate && isFirst && (
                      <td rowSpan={groupSize}>{moment(order.order_date).format('DD/MM/YYYY')}</td>
                    )}
                    {/* Mã đơn (monthly_id) */}
                    {columnVisibility.monthlyId && isFirst && (
                      <td rowSpan={groupSize}>{this.formatMonthlyIdToHuman(order.monthly_id) || '-'}</td>
                    )}
                    {/* Order ID */}
                    {columnVisibility.orderId && isFirst && (
                      <td rowSpan={groupSize}>{order.order_id}</td>
                    )}
                    {/* Shop */}
                    {columnVisibility.shop && isFirst && (
                      <td rowSpan={groupSize}>{order.shop_name}</td>
                    )}
                    {/* Khách hàng */}
                    {columnVisibility.customer && isFirst && (
                      <td rowSpan={groupSize}>{this.getDisplayCustomerName(order)}</td>
                    )}
                    {/* Trạng thái */}
                    {columnVisibility.status && isFirst && (
                      <td rowSpan={groupSize}>
                        <div className="d-flex align-items-center gap-2">
                          <Form.Select
                            size="sm"
                            value={order.status}
                            onChange={(e) => this.handleStatusChange(order.order_id, e.target.value)}
                            style={{ width: 'auto' }}
                            disabled={targetPage === 'rnd'}
                          >
                            {this.getAvailableStatuses(order.status).map((status) => (
                              <option key={status.value} value={status.value}>
                                [{status.value}] {getTranslate(LANGUAGE_KEYS[`TEXT_${status.text}`])}
                              </option>
                            ))}
                          </Form.Select>
                          {this.renderStatusBadge(order.status)}
                        </div>
                      </td>
                    )}
                    {/* Priority */}
                    {columnVisibility.priority && isFirst && (
                      <td rowSpan={groupSize}>
                        {targetPage === 'sale' ? (
                          <Form.Select
                            size="sm"
                            value={order.priority || 2}
                            onChange={(e) => this.handlePriorityChange(order.order_id, e.target.value)}
                            style={{ width: 'auto' }}
                          >
                            {[1, 2, 3, 4].map(priority => (
                              <option key={priority} value={priority}>
                                {this.renderPriorityOption(priority).props.children[1].props.children}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              backgroundColor: this.getPriorityInfo(order.priority || 2).bgColor,
                              border: '1px solid #ccc'
                            }} />
                            {this.renderPriorityBadge(order.priority || 2)}
                          </div>
                        )}
                      </td>
                    )}
                    {/* SKU */}
                    {columnVisibility.sku && (
                      <td>
                        <span style={{ 
                          color: !isSkuValid ? '#dc3545' : 'inherit',
                          fontWeight: !isSkuValid ? 'bold' : 'normal'
                        }}>
                          {listing.sku}
                        </span>
                      </td>
                    )}
                    {/* Ảnh */}
                    {columnVisibility.image && <td style={{ minWidth: '80px' }}>
                      <img
                        src={listing.img_url?.replace("75x75", "120x120")}
                        alt={listing.title}
                        style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                      />
                    </td>}
                    {/* Tên sản phẩm */}
                    {columnVisibility.title && <td style={{ maxWidth: '150px', fontSize: '0.9em', position: 'relative' }}>
                      {listing.title?.length > 40 ? `${listing.title.substring(0, 40)}...` : listing.title || '-'}
                      {targetPage === 'sale' && (
                        <Button
                          variant="link"
                          size="sm"
                          style={{ boxShadow: 'none', border: 'none', background: 'none', padding: 0, marginLeft: 4, position: 'absolute', right: 0, top: 0 }}
                          onClick={() => this.handleEditListingOnly(order, listing, idxInGroup)}
                          title="Sửa sản phẩm"
                        >
                          <FaEdit />
                        </Button>
                      )}
                    </td>}
                    {/* Kích thước */}
                    {columnVisibility.size && (
                      <td style={{ 
                        backgroundColor: !size ? '#dc3545' : 'inherit',
                        color: !isSizeValid ? '#dc3545' : 'inherit',
                        fontWeight: !isSizeValid ? 'bold' : 'normal'
                      }}>
                        {listing.size || '-'}
                      </td>
                    )}
                    {/* Số lượng */}
                    {columnVisibility.quantity && (
                      <td style={{ 
                        backgroundColor: (listing.quantity || 0) > 1 ? '#fff3cd' : 'inherit',
                        fontWeight: (listing.quantity || 0) > 1 ? 'bold' : 'normal'
                      }}>
                        {!listing.quantity || listing.quantity === 0 ? 1 : listing.quantity}
                      </td>
                    )}
                    {/* Ghi chú khách */}
                    {columnVisibility.buyerNote && isFirst && (
                      <td rowSpan={groupSize} style={{ minWidth: '150px', fontSize: '0.9em' }}>
                        {this.state.editingBuyerNote === order.order_id ? (
                          targetPage === 'sale' ? (
                            <div>
                              <Form.Control
                                as="textarea"
                                rows={5}
                                value={this.state.buyerNoteValue}
                                onChange={this.handleBuyerNoteChange}
                                style={{ fontSize: '0.9em', width: '100%', resize: 'vertical' }}
                              />
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => this.handleBuyerNoteSave(order.order_id)}
                                  style={{ marginRight: 8 }}
                                >
                                  <FaCheck />
                                </Button>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  onClick={() => this.setState({ editingBuyerNote: null })}
                                >
                                  {getTranslate(LANGUAGE_KEYS.TEXT_CANCEL)}
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <span>{order.buyer_note || '-'}</span>
                          )
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ flex: 1 }}>{order.buyer_note || '-'}</span>
                            {targetPage === 'sale' && (
                              <Button
                                variant="link"
                                size="sm"
                                style={{ boxShadow: 'none', border: 'none', background: 'none', padding: '0 4px', marginLeft: 4 }}
                                onClick={() => this.handleBuyerNoteEdit(order.order_id)}
                                title="Sửa ghi chú khách"
                              >
                                <FaEdit />
                              </Button>
                            )}
                          </div>
                        )}
                      </td>
                    )}
                    {/* Ghi chú nhân viên */}
                    {columnVisibility.sellerNote && isFirst && (
                      <td rowSpan={groupSize} style={{ minWidth: '150px', fontSize: '0.9em' }}>
                        {this.state.editingNote === order.order_id ? (
                          targetPage === 'sale' ? (
                            <div>
                              <Form.Control
                                as="textarea"
                                rows={5}
                                value={this.state.noteValue}
                                onChange={this.handleNoteChange}
                                style={{ fontSize: '0.9em', width: '100%', resize: 'vertical' }}
                              />
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => this.handleNoteSave(order.order_id)}
                                  style={{ marginRight: 8 }}
                                >
                                  <FaCheck />
                                </Button>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  onClick={() => this.setState({ editingNote: null })}
                                >
                                  {getTranslate(LANGUAGE_KEYS.TEXT_CANCEL)}
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <span>{order.seller_note || '-'}</span>
                          )
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ flex: 1 }}>{order.seller_note || '-'}</span>
                            {targetPage === 'sale' && (
                              <Button
                                variant="link"
                                size="sm"
                                style={{ boxShadow: 'none', border: 'none', background: 'none', padding: '0 4px', marginLeft: 4 }}
                                onClick={() => this.handleNoteEdit(order.order_id)}
                                title="Sửa ghi chú"
                              >
                                <FaEdit />
                              </Button>
                            )}
                          </div>
                        )}
                      </td>
                    )}
                    {/* Est Delivery */}
                    {columnVisibility.estDelivery && isFirst && (
                      <td rowSpan={groupSize}>{order.est_delivery_date}</td>
                    )}
                    {/* Địa chỉ giao hàng */}
                    {columnVisibility.shippingAddress && isFirst && (
                      <td rowSpan={groupSize} style={{ whiteSpace: 'pre-line', fontSize: '0.9em' }}>{order.shipping_address}</td>
                    )}
                    {/* Email */}
                    {columnVisibility.email && isFirst && (
                      <td rowSpan={groupSize} style={{ fontSize: '0.9em' }}>{order.email}</td>
                    )}
                    {/* IOSS */}
                    {columnVisibility.ioss && isFirst && (
                      <td rowSpan={groupSize} style={{ fontSize: '0.9em' }}>{order.ioss || '-'}</td>
                    )}
                    {/* Check kho (Available) */}
                    {columnVisibility.available && order.status < 13 && (
                      <td>
                        {targetPage === 'fulfill' ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Form.Select
                              size="sm"
                              value={listing.available || 0}
                              onChange={(e) => this.handleAvailableChange(order.order_id, listing.sku, e.target.value)}
                              style={{ width: 'auto' }}
                            >
                              <option value={-1}>{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_PENDING)}</option>
                              <option value={0}>{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_OUT_OF_STOCK)}</option>
                              <option value={1}>{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_IN_STOCK)}</option>
                              <option value={2}>{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_RESERVED)}</option>
                            </Form.Select>
                            {listing.available === 1 && <Badge bg="success">&nbsp;</Badge>}
                            {listing.available === 0 && <Badge bg="danger">&nbsp;</Badge>}
                            {listing.available === 2 && <Badge bg="warning" text="dark">&nbsp;</Badge>}
                            {listing.available === -1 && <Badge bg="secondary">&nbsp;</Badge>}
                            {(listing.available !== 0 && listing.available !== 1 && listing.available !== 2 && listing.available !== -1) && <Badge bg="dark">&nbsp;</Badge>}
                          </div>
                        ) : (
                          <>
                            {listing.available === 1 && <Badge bg="success">{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_IN_STOCK)}</Badge>}
                            {listing.available === 0 && <Badge bg="danger">{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_OUT_OF_STOCK)}</Badge>}
                            {listing.available === 2 && <Badge bg="warning" text="dark">{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_RESERVED)}</Badge>}
                            {listing.available === -1 && <Badge bg="secondary">{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_PENDING)}</Badge>}
                            {(listing.available !== 0 && listing.available !== 1 && listing.available !== 2 && listing.available !== -1) && <Badge bg="dark">{getTranslate(LANGUAGE_KEYS.TEXT_AVAILABLE_UNKNOWN)}</Badge>}
                          </>
                        )}
                      </td>
                    )}
                    {columnVisibility.available && order.status >= 13 && (
                      <td></td>
                    )}
                    {/* Ngày ship ĐVVC */}
                    {columnVisibility.shippingCenterDate && isFirst && (
                      <td rowSpan={groupSize} style={{ whiteSpace: 'nowrap' }}>
                        {order.shipping_center_date ? moment(order.shipping_center_date).format('DD/MM/YYYY HH:mm') : '-'}
                      </td>
                    )}
                    {/* Thao tác */}
                    {columnVisibility.action && isFirst && (
                      <td rowSpan={groupSize}>
                        <div className="d-flex gap-2">
                          {targetPage === 'sale' && (
                            <>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => this.handleEditOrderOnly(order)}
                              >
                                {getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
                              </Button>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => this.handleAddListingToOrder(order)}
                              >
                                {getTranslate(LANGUAGE_KEYS.TEXT_ADD_LISTING)}
                              </Button>
                            </>
                          )}
                          {targetPage === 'rnd' && (
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() => this.handleShowRndDoneModal(order.order_id)}
                            >
                              Done Custom
                            </Button>
                          )}
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => this.handleViewLogs(order)}
                          >
                            <FaHistory />
                          </Button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              });
            })()}
          </tbody>
        </Table>

        <div className="d-flex justify-content-center mt-3">
          {Math.ceil(totalCount / itemsPerPage) > 1 && (
            <div className="d-flex align-items-center">
              <Button
                variant="outline-primary"
                className="me-2"
                disabled={currentPage === 1}
                onClick={() => this.handlePageChange(currentPage - 1)}
              >
                {getTranslate(LANGUAGE_KEYS.TEXT_PREVIOUS)}
              </Button>
              <span className="mx-2">
                {getTranslate(LANGUAGE_KEYS.TEXT_PAGE)} {currentPage} / {Math.ceil(totalCount / itemsPerPage)}
              </span>
              <Button
                variant="outline-primary"
                className="ms-2"
                disabled={currentPage === Math.ceil(totalCount / itemsPerPage)}
                onClick={() => this.handlePageChange(currentPage + 1)}
              >
                {getTranslate(LANGUAGE_KEYS.TEXT_NEXT)}
              </Button>
            </div>
          )}
        </div>
        <div style={{ paddingBottom: 40 }} />

        <Modal show={showEditModal} onHide={() => this.setState({ showEditModal: false, isAddingListing: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.isAddingListing ? 
                `Thêm listing cho order [${this.state.currentOrder?.monthly_id ? this.formatMonthlyIdToHuman(this.state.currentOrder.monthly_id) : '-'}]` :
                getTranslate(LANGUAGE_KEYS.TEXT_EDIT_LISTING_ORDER_NOTE)
              }
              {this.state.currentOrder && !this.state.isAddingListing && (
                <span className="ms-2 text-muted">
                  [{this.state.currentOrder.monthly_id ? this.formatMonthlyIdToHuman(this.state.currentOrder.monthly_id) : '-'}] {this.state.currentOrder.order_id}
                </span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {(this.state.editMode === 'listing' || this.state.isAddingListing) && (
                <>
                  <h5>{getTranslate(LANGUAGE_KEYS.TEXT_LISTING_DETAILS)}</h5>
                  <Row className="align-items-center">
                    <Col md={7}>
                      <Form.Group className="mb-3">
                        <Form.Label>Chọn sản phẩm</Form.Label>
                        <Select
                          value={productOptions.find(option => option.value === (this.state.currentListing && this.state.currentListing.product_code)) || null}
                          onChange={option => {
                            if (option) {
                              const selectedProduct = this.props.products.find(p => p.product_code === option.value);
                              if (selectedProduct) {
                                this.setState(prevState => ({
                                  editForm: {
                                    ...prevState.editForm,
                                    sku: selectedProduct.sku_code,
                                    size: selectedProduct.size,
                                    title: selectedProduct.product_name,
                                    product_code: selectedProduct.product_code
                                  },
                                  currentListing: {
                                    ...prevState.currentListing,
                                    product_code: selectedProduct.product_code,
                                    sku: selectedProduct.sku_code,
                                    size: selectedProduct.size,
                                    title: selectedProduct.product_name,
                                    img_url: selectedProduct.images && selectedProduct.images.length > 0 
                                      ? selectedProduct.images[0].image_link 
                                      : ''
                                  }
                                }));
                              }
                            } else {
                              this.setState(prevState => ({
                                editForm: {
                                  ...prevState.editForm,
                                  sku: '',
                                  size: '',
                                  title: '',
                                  product_code: ''
                                },
                                currentListing: {
                                  ...prevState.currentListing,
                                  product_code: '',
                                  sku: '',
                                  size: '',
                                  title: '',
                                  img_url: ''
                                }
                              }));
                            }
                          }}
                          options={productOptions}
                          isClearable
                          isSearchable
                          placeholder="Chọn sản phẩm (product_code)..."
                          noOptionsMessage={() => "Không tìm thấy sản phẩm"}
                          formatOptionLabel={option => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {option.img_url && (
                                <img src={option.img_url} alt="" style={{ width: 32, height: 32, marginRight: 8, objectFit: 'cover', borderRadius: 4 }} />
                              )}
                              <div>
                                <div>{option.label}</div>
                                <small className="text-muted">SKU: {option.sku_code} - Size: {option.size}</small>
                              </div>
                            </div>
                          )}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)}</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          value={editForm.title}
                          onChange={this.handleEditFormChange}
                          readOnly
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Số lượng</Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          name="quantity"
                          value={editForm.quantity}
                          onChange={this.handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5} className="text-center">
                      {this.state.currentListing && this.state.currentListing.img_url && (
                        <img
                          src={this.state.currentListing.img_url?.replace("75x75", "180x180")}
                          alt={editForm.title}
                          style={{ width: 180, height: 180, objectFit: 'cover', border: '1px solid #eee', borderRadius: 6, marginTop: 8 }}
                        />
                      )}
                    </Col>
                  </Row>
                </>
              )}
              {this.state.editMode === 'order' && !this.state.isAddingListing && (
                <>
                  <h5>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER_INFO)}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_name"
                          value={editForm.customer_name}
                          onChange={this.handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_EMAIL)}</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={editForm.email}
                          onChange={this.handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</Form.Label>
                        <Form.Control
                          type="text"
                          name="ioss"
                          value={editForm.ioss || ''}
                          onChange={this.handleEditFormChange}
                          placeholder="Enter IOSS number..."
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SHIPPING_ADDRESS)}</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          name="shipping_address"
                          value={editForm.shipping_address}
                          onChange={this.handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</Form.Label>
                        <div className="react-datepicker-container-custom">
                          <DatePicker
                            selected={editForm.order_date}
                            onChange={(date) => this.handleEditFormChange({ target: { name: 'order_date', value: date } })}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Chọn ngày đặt hàng..."
                            maxDate={new Date()}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRIORITY)}</Form.Label>
                        <Form.Select
                          name="priority"
                          value={editForm.priority}
                          onChange={this.handleEditFormChange}
                        >
                          {[1, 2, 3, 4].map(priority => (
                            <option key={priority} value={priority}>
                              {this.renderPriorityOption(priority).props.children[1].props.children}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_NOTES)}</h5>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="buyer_note"
                      value={editForm.buyer_note}
                      onChange={this.handleEditFormChange}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SELLER_NOTE)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="seller_note"
                      value={editForm.seller_note}
                      onChange={this.handleEditFormChange}
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <div className="d-flex w-100 justify-content-between align-items-center">
              {!this.state.isAddingListing && this.state.editMode === 'listing' && (
                <div>
                  <Button variant="danger" onClick={this.handleDeleteListing}>
                    Xoá Listing
                  </Button>
                </div>
              )}
              <div>
                <Button variant="secondary" onClick={() => this.setState({ showEditModal: false, isAddingListing: false })} className="me-2">
                  {getTranslate(LANGUAGE_KEYS.TEXT_CANCEL)}
                </Button>
                {targetPage === 'sale' && (
                  <Button variant="primary" onClick={this.handleEditSubmit}>
                    {getTranslate(LANGUAGE_KEYS.TEXT_SAVE_CHANGES)}
                  </Button>
                )}
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{getTranslate(LANGUAGE_KEYS.TEXT_CONFIGURE_VIEW_COLUMNS)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Table Settings</h6>
                <Form.Check
                  type="switch"
                  id="stick-header"
                  label="Stick Header (Freeze table header when scrolling)"
                  checked={this.state.stickHeader}
                  onChange={this.handleStickHeaderToggle}
                  className="mb-2"
                />
              </div>
              <hr />
              <div className="mb-3">
                <h6>Column Visibility</h6>
                {Object.entries(columnVisibility).map(([column, isVisible]) => {
                  // Map column keys to language keys for special cases
                  const columnKeyToLangKey = {
                    title: 'TEXT_PRODUCT_NAME',
                    available: 'TEXT_AVAILABLE',
                    // Add more special cases if needed
                  };
                  const langKey = columnKeyToLangKey[column] || `TEXT_${column.replace(/([A-Z])/g, '_$1').toUpperCase()}`;
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={getTranslate(LANGUAGE_KEYS[langKey]) || column.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
                <Form.Check
                  type="switch"
                  id="column-stt"
                  label="STT"
                  checked={columnVisibility.stt}
                  onChange={() => this.handleColumnToggle('stt')}
                  className="mb-2"
                />
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              {getTranslate(LANGUAGE_KEYS.TEXT_CANCEL)}
            </Button>
            <Button variant="primary" onClick={this.handleSaveConfig}>
              {getTranslate(LANGUAGE_KEYS.TEXT_SAVE_VIEW)}
            </Button>
          </Modal.Footer>
        </Modal>

        <ScanOrders show={showScanOrdersModal} onHide={() => this.setState({ showScanOrdersModal: false })} />

        <Modal show={showRndDoneModal} onHide={() => this.setState({ showRndDoneModal: false, rndOrderId: null, rndNoteValue: '' })}>
          <Modal.Header closeButton>
            <Modal.Title>Hoàn thành đơn custom</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Ghi chú RnD</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={rndNoteValue}
                  onChange={this.handleRndNoteChange}
                  placeholder="Nhập ghi chú cho RnD..."
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showRndDoneModal: false, rndOrderId: null, rndNoteValue: '' })}>
              Đóng
            </Button>
            <Button variant="success" onClick={this.handleRndDoneSubmit}>
              Xác nhận hoàn thành
            </Button>
          </Modal.Footer>
        </Modal>

        <StrapModal
          isOpen={showLogModal}
          toggle={() => this.setState({ showLogModal: false })}
          size="xl"
          className="modal-order-logs"
          style={{ maxWidth: '90vw', width: '90vw', margin: '0 auto', zIndex: 1050 }}
          centered
        >
          <ModalHeader toggle={() => this.setState({ showLogModal: false })}>
            <strong>Order Logs - {currentOrderForLog?.monthly_id ? this.formatMonthlyIdToHuman(currentOrderForLog.monthly_id) : currentOrderForLog?.order_id}</strong>
          </ModalHeader>
          <ModalBody>
            <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap" style={{ gap: 16 }}>
              <div className="d-flex align-items-center flex-nowrap" style={{ gap: 16 }}>
                <Form.Check
                  type='switch'
                  label="Latest Log"
                  checked={isShowLatestLog}
                  onChange={this.handleToggleShowLatestLog}
                  style={{ marginBottom: 0, width: 200 }}
                />
                <Form.Select
                  size="sm"
                  value={this.state.logLevelFilter}
                  onChange={e => this.setState({ logLevelFilter: e.target.value })}
                  style={{ minWidth: 120 }}
                >
                  <option value="ALL">Tất cả</option>
                  <option value="1">Level 1</option>
                  <option value="2">Level 2</option>
                  <option value="3">Level 3</option>
                  <option value="4">Level 4</option>
                </Form.Select>
              </div>
              <div className="d-flex align-items-center" style={{ gap: 12 }}>
                <span className="text-muted" style={{ whiteSpace: 'nowrap' }}>Total Logs: {logPagination.totalCount}</span>
                <Button
                  className="btn-fill btn-sm"
                  variant="primary"
                  onClick={this.handleGetLatestLog}
                >
                  Reload
                </Button>
              </div>
            </div>

            {currentOrderForLog && (
              <div className='text-white mb-4'>
                <Badge pill bg="primary">Order ID: {currentOrderForLog.order_id}</Badge>
                <Badge pill bg="primary" className='ms-2'>Shop: {currentOrderForLog.shop_name}</Badge>
                <Badge pill bg="primary" className='ms-2'>Status: {this.getOrderStatusInfo(currentOrderForLog.status).text}</Badge>
                <Badge pill bg="primary" className='ms-2'>Created: {moment(currentOrderForLog.order_date).format('YYYY/MM/DD HH:mm:ss')}</Badge>
              </div>
            )}

            <div className="modal-order-logs-list" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {currentOrderLogs.length > 0 ? (
                <Table bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Team</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      let logs = currentOrderLogs
                        .filter(log => {
                          if (!isShowLatestLog) return true;
                          // Show only last 100 logs if isShowLatestLog is true
                          return currentOrderLogs.indexOf(log) >= currentOrderLogs.length - 100;
                        })
                        .filter(log => {
                          if (this.state.logLevelFilter === 'ALL') return true;
                          return String(log.level) === this.state.logLevelFilter;
                        });
                      // Sắp xếp thứ tự log theo toggle
                      if (isShowLatestLog) {
                        logs = [...logs].sort((a, b) => new Date(b.time) - new Date(a.time));
                      } else {
                        logs = [...logs].sort((a, b) => new Date(a.time) - new Date(b.time));
                      }
                      return logs.map((log, index) => {
                        let rowStyle = {};
                        if (log.level === 1) {
                          rowStyle = { background: '#ffe5e5', color: '#b30000', fontWeight: 'bold' };
                        } else if (log.level === 2) {
                          rowStyle = { background: '#fff5e5', color: '#b36b00', fontWeight: 'bold' };
                        } else if (log.level === 3) {
                          rowStyle = { background: '#e5f0ff', color: '#005cb3' };
                        } else if (log.level === 4) {
                          rowStyle = { background: '#f2f2f2', color: '#666' };
                        }
                        return (
                          <tr key={log._id} style={rowStyle}>
                            <td style={{ whiteSpace: 'nowrap' }}>{moment(log.time).format('YYYY/MM/DD HH:mm:ss')}</td>
                            <td>{log.perform_by_team || '-'}</td>
                            <td>{log.perform_by_user || '-'}</td>
                            <td>{log.status !== undefined ? `[${log.status}] ${getTranslate(LANGUAGE_KEYS['TEXT_' + this.getOrderStatusInfo(log.status).text])}` : ''}</td>
                            <td style={{ fontStyle: log.level === 9 ? 'italic' : 'normal', fontWeight: log.level === 1 ? 'bold' : 'normal' }}>
                              {log.message}
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                  <span className="ms-2">Loading logs...</span>
                </div>
              )}
            </div>

            {logPagination.totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <div className="d-flex align-items-center">
                  <Button
                    variant="outline-primary"
                    className="me-2"
                    disabled={logPagination.currentPage === 1}
                    onClick={() => this.handleLogPageChange(logPagination.currentPage - 1)}
                  >
                    {getTranslate(LANGUAGE_KEYS.TEXT_PREVIOUS)}
                  </Button>
                  <span className="mx-2">
                    {getTranslate(LANGUAGE_KEYS.TEXT_PAGE)} {logPagination.currentPage} / {logPagination.totalPages}
                  </span>
                  <Button
                    variant="outline-primary"
                    className="ms-2"
                    disabled={logPagination.currentPage === logPagination.totalPages}
                    onClick={() => this.handleLogPageChange(logPagination.currentPage + 1)}
                  >
                    {getTranslate(LANGUAGE_KEYS.TEXT_NEXT)}
                  </Button>
                </div>
              </div>
            )}
          </ModalBody>
        </StrapModal>

        {/* Replace the old Warehouse Modal with IframeModal */}
        <IframeModal
          show={showWarehouseModal}
          onHide={() => this.setState({ showWarehouseModal: false })}
          url={targetPage === 'sale' ? "/admin/sale/product-list" : "/admin/fulfill/product-list"}
          title="Warehouse Products"
        />

        {/* Add Fulfill Label Modal */}
        <StrapModal
          isOpen={showFulfillLabelModal}
          toggle={() => this.setState({ showFulfillLabelModal: false })}
          size="xl"
          centered
          className="iframe-modal"
          style={{
            maxWidth: '95vw',
            width: '95vw',
            margin: '0 auto',
            zIndex: 1050
          }}
        >
          <ModalHeader toggle={() => this.setState({ showFulfillLabelModal: false })}>
            Orders to Fulfill ({ordersToFulfill.length})
          </ModalHeader>
          <ModalBody style={{ padding: 0 }}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={this.state.activeTab === '0' ? 'active' : ''}
                  onClick={() => this.toggleTab('0')}
                >
                  Tất cả đơn nợ ({ordersToFulfill.length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={this.state.activeTab === '1' ? 'active' : ''}
                  onClick={() => this.toggleTab('1')}
                >
                  {getTranslate(LANGUAGE_KEYS.TEXT_SHIPPABLE_ORDERS)} ({ordersToFulfill.filter(order => 
                    order.listings.some(listing => listing.available === 1 || listing.available === 2)
                  ).length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={this.state.activeTab === '2' ? 'active' : ''}
                  onClick={() => this.toggleTab('2')}
                >
                  {getTranslate(LANGUAGE_KEYS.TEXT_WAREHOUSE_LAMPS)} ({(() => {
                    const groupedOrders = {};
                    ordersToFulfill.forEach(order => {
                      order.listings
                        .filter(listing => listing.available === 1 || listing.available === 2)
                        .forEach(listing => {
                          const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                          if (!groupedOrders[key]) {
                            groupedOrders[key] = {
                              sku: listing.sku,
                              size: listing.size,
                              quantity: 0,
                              cell: listing.current_cell_code,
                              monthlyIds: new Set()
                            };
                          }
                          groupedOrders[key].quantity += 1;
                          groupedOrders[key].monthlyIds.add(order.monthly_id);
                        });
                    });
                    return Object.values(groupedOrders).reduce((sum, item) => sum + item.quantity, 0);
                  })()})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={this.state.activeTab === '3' ? 'active' : ''}
                  onClick={() => this.toggleTab('3')}
                >
                  {getTranslate(LANGUAGE_KEYS.TEXT_OUT_OF_STOCK_LAMPS)} ({(() => {
                    const groupedOrders = {};
                    ordersToFulfill.forEach(order => {
                      order.listings
                        .filter(listing => listing.available === 0)
                        .forEach(listing => {
                          const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                          if (!groupedOrders[key]) {
                            groupedOrders[key] = {
                              sku: listing.sku,
                              size: listing.size,
                              quantity: 0,
                              cell: listing.current_cell_code,
                              monthlyIds: new Set()
                            };
                          }
                          groupedOrders[key].quantity += 1;
                          groupedOrders[key].monthlyIds.add(order.monthly_id);
                        });
                    });
                    return Object.values(groupedOrders).reduce((sum, item) => sum + item.quantity, 0);
                  })()})
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="0">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <strong>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ORDERS)}: {ordersToFulfill.length}</strong>
                  </div>
                  <Button variant="primary" onClick={() => this.handlePrint('allfulfill')}> 
                    <FaPrint className="me-2" />
                    Print
                  </Button>
                </div>
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <Table striped bordered hover responsive size="sm" style={{ width: '100%', tableLayout: 'fixed' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_ID)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_NAME)}</th>
                        <th style={{ width: '5%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_USER_NOTE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ADDRESS)}</th>
                        <th style={{ width: '7%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                        <th style={{ width: '7%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ordersToFulfill.map(order => 
                        order.listings.map((listing, index) => (
                          <tr key={`${order.order_id}-${listing.sku}-${index}`}>
                            <td style={{ whiteSpace: 'nowrap' }}>{moment(order.order_date).format('DD/MM/YYYY')}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{this.formatMonthlyIdToHuman(order.monthly_id) || '-'}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{order.order_id}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{order.shop_name}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{order.customer_name}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{listing.sku}</td>
                            <td style={{ minWidth: '80px' }}>
                              <img
                                src={listing.img_url?.replace("75x75", "120x120")}
                                alt={listing.title}
                                style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                              />
                            </td>
                            <td style={{ maxWidth: '150px', fontSize: '0.9em' }}>
                              {listing.title?.length > 40 ? `${listing.title.substring(0, 40)}...` : listing.title}
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>{listing.size}</td>
                            <td style={{ minWidth: '150px', fontSize: '0.9em' }}>{order.buyer_note || '-'}</td>
                            <td style={{ minWidth: '150px', fontSize: '0.9em' }}>{order.seller_note || '-'}</td>
                            <td style={{ whiteSpace: 'pre-line', fontSize: '0.9em' }}>{order.shipping_address}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{listing.current_cell_code || '-'}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{order.ioss || '-'}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </TabPane>
              <TabPane tabId="1">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <strong>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ORDERS)}: {ordersToFulfill.filter(order => 
                      order.listings.some(listing => listing.available === 1 || listing.available === 2)
                    ).length}</strong>
                  </div>
                  <Button variant="primary" onClick={() => this.handlePrint('shipping')}>
                    <FaPrint className="me-2" />
                    Print
                  </Button>
                </div>
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <Table striped bordered hover responsive size="sm" style={{ width: '100%', tableLayout: 'fixed' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_ID)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                        <th style={{ width: '8%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_NAME)}</th>
                        <th style={{ width: '5%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_USER_NOTE)}</th>
                        <th style={{ width: '10%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_ADDRESS)}</th>
                        <th style={{ width: '7%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                        <th style={{ width: '7%' }}>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ordersToFulfill.map(order => 
                        order.listings
                          .filter(listing => listing.available === 1 || listing.available === 2)
                          .map((listing, index) => (
                            <tr key={`${order.order_id}-${listing.sku}-${index}`}>
                              <td style={{ whiteSpace: 'nowrap' }}>{moment(order.order_date).format('DD/MM/YYYY')}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{this.formatMonthlyIdToHuman(order.monthly_id) || '-'}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{order.order_id}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{order.shop_name}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{order.customer_name}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{listing.sku}</td>
                              <td style={{ minWidth: '80px' }}>
                                <img
                                  src={listing.img_url?.replace("75x75", "120x120")}
                                  alt={listing.title}
                                  style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                />
                              </td>
                              <td style={{ maxWidth: '150px', fontSize: '0.9em' }}>
                                {listing.title?.length > 40 ? `${listing.title.substring(0, 40)}...` : listing.title}
                              </td>
                              <td style={{ whiteSpace: 'nowrap' }}>{listing.size}</td>
                              <td style={{ minWidth: '150px', fontSize: '0.9em' }}>{order.buyer_note || '-'}</td>
                              <td style={{ minWidth: '150px', fontSize: '0.9em' }}>{order.seller_note || '-'}</td>
                              <td style={{ whiteSpace: 'pre-line', fontSize: '0.9em' }}>{order.shipping_address}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{listing.current_cell_code || '-'}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{order.ioss || '-'}</td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <strong>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_LAMPS)}: {(() => {
                      const groupedOrders = {};
                      ordersToFulfill.forEach(order => {
                        order.listings
                          .filter(listing => listing.available === 1 || listing.available === 2)
                          .forEach(listing => {
                            const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                            if (!groupedOrders[key]) {
                              groupedOrders[key] = {
                                sku: listing.sku,
                                size: listing.size,
                                quantity: 0,
                                cell: listing.current_cell_code,
                                monthlyIds: new Set()
                              };
                            }
                            groupedOrders[key].quantity += 1;
                            groupedOrders[key].monthlyIds.add(order.monthly_id);
                          });
                      });
                      return Object.values(groupedOrders).reduce((sum, item) => sum + item.quantity, 0);
                    })()}</strong>
                  </div>
                  <Button variant="primary" onClick={() => this.handlePrint('warehouse')}>
                    <FaPrint className="me-2" />
                    {getTranslate(LANGUAGE_KEYS.TEXT_PRINT)}
                  </Button>
                </div>
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <Table striped bordered hover responsive size="sm">
                    <thead>
                      <tr>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const groupedOrders = {};
                        ordersToFulfill.forEach(order => {
                          order.listings
                            .filter(listing => listing.available === 1 || listing.available === 2)
                            .forEach(listing => {
                              const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                              if (!groupedOrders[key]) {
                                groupedOrders[key] = {
                                  sku: listing.sku,
                                  size: listing.size,
                                  quantity: 0,
                                  cell: listing.current_cell_code,
                                  monthlyIds: new Set()
                                };
                              }
                              groupedOrders[key].quantity += 1;
                              groupedOrders[key].monthlyIds.add(order.monthly_id);
                            });
                        });

                        // Sort by SKU and size
                        const sizeOrder = { 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4 };
                        return Object.values(groupedOrders)
                          .sort((a, b) => {
                            if (a.sku === b.sku) {
                              return (sizeOrder[a.size] || 0) - (sizeOrder[b.size] || 0);
                            }
                            return a.sku.localeCompare(b.sku);
                          })
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{item.sku}</td>
                              <td>{item.size}</td>
                              <td>{item.quantity}</td>
                              <td>{item.cell || '-'}</td>
                              <td>{Array.from(item.monthlyIds).map(id => this.formatMonthlyIdToHuman(id)).join(', ')}</td>
                            </tr>
                          ));
                      })()}
                    </tbody>
                  </Table>
                </div>
              </TabPane>
              <TabPane tabId="3">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <strong>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_LAMPS)}: {(() => {
                      const groupedOrders = {};
                      ordersToFulfill.forEach(order => {
                        order.listings
                          .filter(listing => listing.available === 0)
                          .forEach(listing => {
                            const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                            if (!groupedOrders[key]) {
                              groupedOrders[key] = {
                                sku: listing.sku,
                                size: listing.size,
                                quantity: 0,
                                cell: listing.current_cell_code,
                                monthlyIds: new Set()
                              };
                            }
                            groupedOrders[key].quantity += 1;
                            groupedOrders[key].monthlyIds.add(order.monthly_id);
                          });
                      });
                      return Object.values(groupedOrders).reduce((sum, item) => sum + item.quantity, 0);
                    })()}</strong>
                  </div>
                  <Button variant="primary" onClick={() => this.handlePrint('outofstock')}>
                    <FaPrint className="me-2" />
                    {getTranslate(LANGUAGE_KEYS.TEXT_PRINT)}
                  </Button>
                </div>
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <Table striped bordered hover responsive size="sm">
                    <thead>
                      <tr>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_SKU)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_MONTHLY_ID)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const groupedOrders = {};
                        ordersToFulfill.forEach(order => {
                          order.listings
                            .filter(listing => listing.available === 0)
                            .forEach(listing => {
                              const key = `${listing.sku}-${listing.size}-${listing.current_cell_code}`;
                              if (!groupedOrders[key]) {
                                groupedOrders[key] = {
                                  sku: listing.sku,
                                  size: listing.size,
                                  quantity: 0,
                                  cell: listing.current_cell_code,
                                  monthlyIds: new Set()
                                };
                              }
                              groupedOrders[key].quantity += 1;
                              groupedOrders[key].monthlyIds.add(order.monthly_id);
                            });
                        });

                        // Sort by SKU and size
                        const sizeOrder = { 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4 };
                        return Object.values(groupedOrders)
                          .sort((a, b) => {
                            if (a.sku === b.sku) {
                              return (sizeOrder[a.size] || 0) - (sizeOrder[b.size] || 0);
                            }
                            return a.sku.localeCompare(b.sku);
                          })
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{item.sku}</td>
                              <td>{item.size}</td>
                              <td>{item.quantity}</td>
                              <td>{item.cell || '-'}</td>
                              <td>{Array.from(item.monthlyIds).map(id => this.formatMonthlyIdToHuman(id)).join(', ')}</td>
                            </tr>
                          ));
                      })()}
                    </tbody>
                  </Table>
                </div>
              </TabPane>
            </TabContent>
          </ModalBody>
        </StrapModal>

        {/* Add New Order Modal */}
        <Modal show={this.state.showAddOrderModal} onHide={() => this.setState({ showAddOrderModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{getTranslate(LANGUAGE_KEYS.TEXT_ADD_NEW_ORDER)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP)}</Form.Label>
                    <CreatableSelect
                      value={this.state.shopOptions.find(option => option.value === this.state.newOrderForm.shop_name) || null}
                      onChange={this.handleShopNameChange}
                      options={this.state.shopOptions}
                      placeholder="Chọn hoặc nhập tên shop mới..."
                      isClearable
                      isSearchable
                      formatCreateLabel={inputValue => `Tạo shop mới: "${inputValue}"`}
                      noOptionsMessage={() => "Không tìm thấy shop"}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_ORDER_DATE)}</Form.Label>
                    <div className="react-datepicker-container-custom">
                      <DatePicker
                        selected={this.state.newOrderForm.order_date}
                        onChange={(date) => this.handleNewOrderFormChange({ target: { name: 'order_date', value: date } })}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        placeholderText="Chọn ngày đặt hàng..."
                        maxDate={new Date()}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_ADDED_REASON)}</Form.Label>
                    <Form.Select
                      name="added_reason"
                      value={this.state.newOrderForm.added_reason}
                      onChange={this.handleNewOrderFormChange}
                    >
                      <option value="ETSY_NEW_ORDER">{getTranslate(LANGUAGE_KEYS.TEXT_ETSY_NEW_ORDER)}</option>
                      <option value="ETSY_WARRANTY_ORDER">{getTranslate(LANGUAGE_KEYS.TEXT_ETSY_WARRANTY_ORDER)}</option>
                      <option value="NON_ETSY_ORDER">{getTranslate(LANGUAGE_KEYS.TEXT_NON_ETSY_ORDER)}</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mã tham chiếu (Order ID/Monthly ID)</Form.Label>
                    <Form.Control
                      type="text"
                      name="reference_code"
                      value={this.state.newOrderForm.reference_code}
                      onChange={this.handleNewOrderFormChange}
                      placeholder="Nhập Order ID hoặc Monthly ID..."
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CUSTOMER)}</Form.Label>
                    <Form.Control
                      type="text"
                      name="customer_name"
                      value={this.state.newOrderForm.customer_name}
                      onChange={this.handleNewOrderFormChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_EMAIL)}</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={this.state.newOrderForm.email}
                      onChange={this.handleNewOrderFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                {/* <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</Form.Label>
                    <Form.Control
                      type="text"
                      name="ioss"
                      value={this.state.newOrderForm.ioss || ''}
                      onChange={this.handleNewOrderFormChange}
                      placeholder="Enter IOSS number..."
                    />
                  </Form.Group>
                </Col> */}
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SHIPPING_ADDRESS)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="shipping_address"
                      value={this.state.newOrderForm.shipping_address}
                      onChange={this.handleNewOrderFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRIORITY)}</Form.Label>
                    <Form.Select
                      name="priority"
                      value={this.state.newOrderForm.priority}
                      onChange={this.handleNewOrderFormChange}
                    >
                      {[1, 2, 3, 4].map(priority => (
                        <option key={priority} value={priority}>
                          {this.renderPriorityOption(priority).props.children[1].props.children}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_IOSS)}</Form.Label>
                    <Form.Control
                      type="text"
                      name="ioss"
                      value={this.state.newOrderForm.ioss || ''}
                      onChange={this.handleNewOrderFormChange}
                      placeholder="Enter IOSS number..."
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_BUYER_NOTE)}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="buyer_note"
                        value={this.state.newOrderForm.buyer_note}
                        onChange={this.handleNewOrderFormChange}
                      />
                    </Form.Group>
                  </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SELLER_NOTE)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="seller_note"
                      value={this.state.newOrderForm.seller_note}
                      onChange={this.handleNewOrderFormChange}
                    />
                    <Form.Text className="text-muted">
                      Mã tham chiếu sẽ tự động được thêm vào đầu ghi chú
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <hr />
              <h5>{getTranslate(LANGUAGE_KEYS.TEXT_LISTING_DETAILS)}</h5>
              {this.state.newOrderForm.listings.map((listing, index) => {
                const selectedOption = productOptions.find(option => option.value === listing.product_code) || null;
                return (
                  <div key={index} className="mb-3 p-3 border rounded">
                    <Row className="align-items-center">
                      <Col md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Chọn sản phẩm</Form.Label>
                          <Select
                            value={selectedOption}
                            onChange={option => this.handleNewOrderListingChange(index, 'product', option)}
                            options={productOptions}
                            isClearable
                            isSearchable
                            placeholder="Chọn sản phẩm (product_code)..."
                            noOptionsMessage={() => "Không tìm thấy sản phẩm"}
                            formatOptionLabel={option => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {option.img_url && (
                                  <img src={option.img_url} alt="" style={{ width: 32, height: 32, marginRight: 8, objectFit: 'cover', borderRadius: 4 }} />
                                )}
                                <span>{option.label}</span>
                              </div>
                            )}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)}</Form.Label>
                          <Form.Control
                            type="text"
                            value={listing.title}
                            readOnly
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Số lượng</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={listing.quantity || 1}
                            onChange={e => this.handleNewOrderListingChange(index, 'quantity', Number(e.target.value))}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="text-center">
                        {listing.img_url && (
                          <img
                            src={listing.img_url?.replace("75x75", "180x180")}
                            alt={listing.title}
                            style={{ width: 180, height: 180, objectFit: 'cover', border: '1px solid #eee', borderRadius: 6, marginTop: 8 }}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showAddOrderModal: false })}>
              {getTranslate(LANGUAGE_KEYS.TEXT_CANCEL)}
            </Button>
            <Button 
              variant="primary"
              onClick={this.handleAddNewOrder}
              disabled={!this.state.newOrderForm.shop_name}
              style={!this.state.newOrderForm.shop_name ? { color: '#222', background: '#e9ecef', borderColor: '#dee2e6' } : {}}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_SAVE)}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Xuất hàng cho fulfill */}
        <Modal show={this.state.showExportModal} onHide={() => this.setState({ showExportModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Xuất hàng (Fulfill)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3 align-items-center">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Đối tác</Form.Label>
                    <Form.Select
                      value={this.state.exportWarehouse}
                      onChange={e => this.setState({ exportWarehouse: e.target.value })}
                    >
                      <option value="">Chọn đối tác...</option>
                      <option value="SAIGONBAY">SAIGONBAY</option>
                      <option value="VIETTEL_POST">VIETTEL POST</option>
                      <option value="OTHER">OTHER</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="export-view-product"
                    label="View Sản phẩm"
                    checked={this.state.exportViewProduct}
                    onChange={e => this.setState({ exportViewProduct: e.target.checked })}
                    className="ms-3"
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      {(() => {
                        const allOrderIds = this.state.exportItems.flatMap(item => item.orderIds.map(oid => oid.monthly_id));
                        const uniqueOrderIds = Array.from(new Set(allOrderIds));
                        return `Danh sách đơn (tổng: ${uniqueOrderIds.length} đơn)`;
                      })()}
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={(() => {
                        const allOrderIds = this.state.exportItems.flatMap(item => item.orderIds.map(oid => oid.monthly_id));
                        const uniqueOrderIds = Array.from(new Set(allOrderIds));
                        return uniqueOrderIds.map(id => this.formatMonthlyIdToHuman(id)).join(', ');
                      })()}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={this.state.exportNote}
                      onChange={e => this.setState({ exportNote: e.target.value })}
                      placeholder="Nhập ghi chú xuất hàng..."
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* Bảng xuất hàng: nếu exportViewProduct thì hiển thị từng listing, ngược lại gộp sản phẩm */}
              {!this.state.exportViewProduct ? (
                <Table bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>Mã đơn</th>
                      <th>Sản phẩm</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      // Lấy danh sách order được chọn
                      const { orders = [] } = this.props;
                      const selectedOrderIds = Array.from(this.state.selectedOrders);
                      const selectedOrders = orders.filter(order => selectedOrderIds.includes(order.order_id));
                      // Gộp sản phẩm giống nhau trong từng order
                      return selectedOrders.map((order, idx) => {
                        const productMap = {};
                        (order.listings || []).forEach(l => {
                          const key = `${l.sku}||${l.size}`;
                          if (!productMap[key]) productMap[key] = { sku: l.sku, size: l.size, qty: 0 };
                          productMap[key].qty += 1;
                        });
                        const productStr = Object.values(productMap)
                          .map(p => `${p.qty} x ${p.sku} (${p.size})`)
                          .join(' + ');
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{this.formatMonthlyIdToHuman(order.monthly_id)}</td>
                            <td>{productStr}</td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </Table>
              ) : (
                <Table bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>SKU</th>
                      <th>Size</th>
                      <th>SL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      // Lấy danh sách order được chọn
                      const { orders = [] } = this.props;
                      const selectedOrderIds = Array.from(this.state.selectedOrders);
                      const selectedOrders = orders.filter(order => selectedOrderIds.includes(order.order_id));
                      // Gộp tất cả listing theo SKU+Size trên toàn bộ các order
                      const productMap = {};
                      selectedOrders.forEach(order => {
                        (order.listings || []).forEach(l => {
                          const key = `${l.sku}||${l.size}`;
                          if (!productMap[key]) productMap[key] = { sku: l.sku, size: l.size, qty: 0 };
                          productMap[key].qty += 1;
                        });
                      });
                      const sizeOrder = { 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4 };
                      const products = Object.values(productMap).sort((a, b) => {
                        if (a.sku === b.sku) {
                          return (sizeOrder[a.size] || 0) - (sizeOrder[b.size] || 0);
                        }
                        return (a.sku || '').localeCompare(b.sku || '');
                      });
                      const totalQty = products.reduce((sum, p) => sum + p.qty, 0);
                      return [
                        ...products.map((p, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{p.sku}</td>
                            <td>{p.size}</td>
                            <td>{p.qty}</td>
                          </tr>
                        )),
                        <tr className="table-info" key="total">
                          <td colSpan="3" className="text-end fw-bold">Tổng số lượng sản phẩm:</td>
                          <td className="fw-bold">{totalQty}</td>
                        </tr>
                      ];
                    })()}
                  </tbody>
                </Table>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showExportModal: false })}>
              Hủy
            </Button>
            <Button
              variant="success"
              onClick={this.handleExportSubmit}
              // disabled={!this.state.exportWarehouse || this.state.exportSaving}
            >
              {this.state.exportSaving ? 'Đang lưu...' : 'Lưu'}
            </Button>
          </Modal.Footer>
        </Modal>
        <div style={{ 
          position: 'fixed', 
          right: '20px', 
          bottom: '20px', 
          zIndex: 9999, 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '10px'
        }}>
          <Button
            variant="primary"
            size="sm"
            style={{ 
              width: '32px', 
              height: '32px', 
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#0d6efd',
              border: 'none',
              boxShadow: '0 2px 8px rgba(13, 110, 253, 0.15)',
              color: '#fff',
              fontSize: 22,
              transition: 'all 0.2s'
            }}
            onClick={() => {
              const panel = document.querySelector('.main-panel');
              if (panel) {
                panel.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            title="Lên đầu trang"
          >
            <FaArrowUp color="#fff" size={18} />
          </Button>
          <Button
            variant="primary"
            size="sm"
            style={{ 
              width: '32px', 
              height: '32px', 
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#0d6efd',
              border: 'none',
              boxShadow: '0 2px 8px rgba(13, 110, 253, 0.15)',
              color: '#fff',
              fontSize: 22,
              transition: 'all 0.2s'
            }}
            onClick={() => {
              const panel = document.querySelector('.main-panel');
              if (panel) {
                panel.scrollTo({ top: panel.scrollHeight, behavior: 'smooth' });
              } else {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
            }}
            title="Xuống cuối trang"
          >
            <FaArrowDown color="#fff" size={18} />
          </Button>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orderReducer.orders,
    products: state.sesProductReducer.products
  };
};

// Export the wrapped component
export default connect(mapStateToProps, {
  getOrders,
  updateOrders,
  getSESProducts,
  setSIVProductInventoryTransaction
})(OrderListWrapper); 